// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-01T17:22:15.128Z
// Property: The Leila Sweetwater (ID: 6767906449167768)
// Collections: 25 amenities, 3 floorplans (live), 48 photos, 78 POIs, 5 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162258",
  "multihub_property_id": "6767906449167768",
  "property_external_id": "100160107",
  "property_zillow_url": "https://www.zillow.com/apartments/lithia-springs-ga/novo-sweetwater/CpzqHk/",
  "property_apartments_url": "https://www.apartments.com/novo-sweetwater-lithia-springs-ga/3xxmlgg/",
  "property_google_business_url": "https://www.google.com/maps/place/Novo+Sweetwater/data=!4m2!3m1!1s0x0:0xef456dfdab5e60b?sa=X&ved=1t:2428&ictx=111",
  "property_linkedin_url": null,
  "property_hubspot_id": "56848929658",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": "5605580",
  "property_status": null,
  "property_slug": "the-leila-sweetwater",
  "property_name": "The Leila Sweetwater",
  "property_website_url": "https://www.theleilasweetwater.com/",
  "property_domain": null,
  "property_address": "1521 Lee Rd",
  "property_full_address": "1521 Lee Rd, Lithia Springs, GA 30122",
  "property_address_1": "1521 Lee Rd",
  "property_address_2": null,
  "property_address_city": "Lithia Springs",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30122",
  "property_address_country": "US",
  "property_address_county": "Douglas County",
  "property_neighborhood_address": "Outlying Douglas County",
  "property_address_latitude": "33.76550630000001",
  "property_address_longitude": "-84.6585862",
  "property_email": null,
  "property_phone": "(470) 444-4521",
  "property_call_tracking_phone": "2293035436",
  "property_company_name": "Axia Residential (ARC Living)",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": "Apartment",
  "property_short_description": "<p><strong>Modern comfort minutes from Sweetwater Creek.</strong> Explore one-, two-, and three-bedroom apartments with polished finishes, relaxed community spaces, and easy I-20 access—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Leila Sweetwater in person.</p>",
  "property_long_description": "<p><strong>Modern comfort, minutes from Sweetwater Creek.</strong> At The Leila Sweetwater, you’re close to the outdoor beauty Lithia Springs is known for while staying connected to I-20, downtown Douglasville, Six Flags Over Georgia, and Atlanta’s westside. Choose from thoughtfully finished one-, two-, and three-bedroom <a href=\"/floor-plans\">apartment layouts</a> with the polished details that make daily life feel elevated.</p><p>Inside, stainless steel appliances, granite counters, 42-inch Shaker-style cabinetry, movable kitchen islands, USB outlets, garden tubs, in-home washer and dryers, wood-style flooring, and 9-foot ceilings create a clean, contemporary backdrop. Beyond your door, unwind at the <a href=\"/amenities\">resort-inspired pool</a> with sun deck, work out in the state-of-the-art fitness center with free weights, meet up in the clubhouse, or simplify the day with controlled access, available garages, a centralized mail hub, and on-site management and service teams.</p><p>From creekside hikes and lake days at Sweetwater Creek State Park to nearby shopping, dining, and everyday essentials, this is Lithia Springs living with room to relax and easy access to what’s next.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-10a2-7599-be26-a95f214122fe.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with in-water loungers and lounge chairs.",
    "public_id": "01a0ca67-10a2-7599-be26-a95f214122fe",
    "storage_key": "property/6767906449167768/01a0ca67-10a2-7599-be26-a95f214122fe.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "298",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "86.57718120805369",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "Security deposit: $500.00 (refundable).",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "20",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply.",
  "property_pet_policy_description": "Pet fee: $400.00 (non-refundable). Monthly pet rent: $20.00/month.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "http://theleilasweetwater.prospectportal.com/",
  "property_resident_portal_url": "https://theleilasweetwater.residentportal.com/auth",
  "property_apply_now_url": "http://theleilasweetwater.prospectportal.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca71-13b4-704a-a003-99b80fd12da2.webp",
  "property_primary_logo_media": {
    "alt_text": "The Leila Sweetwater logo",
    "public_id": "01a0ca71-13b4-704a-a003-99b80fd12da2",
    "storage_key": "property/6767906449167768/01a0ca71-13b4-704a-a003-99b80fd12da2.webp",
    "width": 1467,
    "height": 1158
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca71-1436-718c-a30a-cd86153c6f8f.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Leila Sweetwater logo",
    "public_id": "01a0ca71-1436-718c-a30a-cd86153c6f8f",
    "storage_key": "property/6767906449167768/01a0ca71-1436-718c-a30a-cd86153c6f8f.webp",
    "width": 1467,
    "height": 1158
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca71-142b-73fb-844f-917d6d6c9ea6.webp",
  "property_icon_media": {
    "alt_text": "Abstract gold and white logo with sweeping curves.",
    "public_id": "01a0ca71-142b-73fb-844f-917d6d6c9ea6",
    "storage_key": "property/6767906449167768/01a0ca71-142b-73fb-844f-917d6d6c9ea6.webp",
    "width": 1339,
    "height": 1339
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca71-142b-73fb-844f-917d6d6c9ea6.webp",
  "property_fav_icon_media": {
    "alt_text": "Abstract gold and white logo with sweeping curves.",
    "public_id": "01a0ca71-142b-73fb-844f-917d6d6c9ea6",
    "storage_key": "property/6767906449167768/01a0ca71-142b-73fb-844f-917d6d6c9ea6.webp",
    "width": 1339,
    "height": 1339
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca71-1432-7559-9747-8fd8ee9543e9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Leila Sweetwater logo.",
    "public_id": "01a0ca71-1432-7559-9747-8fd8ee9543e9",
    "storage_key": "property/6767906449167768/01a0ca71-1432-7559-9747-8fd8ee9543e9.webp",
    "width": 1467,
    "height": 1158
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca71-1436-718c-a30a-cd86153c6f8f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Leila Sweetwater logo",
    "public_id": "01a0ca71-1436-718c-a30a-cd86153c6f8f",
    "storage_key": "property/6767906449167768/01a0ca71-1436-718c-a30a-cd86153c6f8f.webp",
    "width": 1467,
    "height": 1158
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-0a7f-7644-86f7-60a98c66fa2f.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162258/019d54d9-c530-7559-a71a-a1a4613d29fc.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#1f2322",
  "property_secondary_color": "#807a0a",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "756 - 1248",
  "property_sqft_min": "756",
  "property_sqft_max": "1248",
  "property_price_range": "$1357 - $2853",
  "property_price_min": "1357",
  "property_price_max": "2853",
  "property_available_units": 40,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ1euDObgh9YgRC-a12t9W9A4",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Leila Sweetwater",
  "property_home_romance_title": "Find Your Sanctuary in Our Charming Apartment Community",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, resort-inspired style.</strong> At The Leila Sweetwater, unwind by the pool and sun deck, keep routines on track in the fitness center with free weights, or spread out in the clubhouse. Inside, one-, two-, and three-bedroom apartments pair granite counters, stainless steel appliances, 42-inch Shaker-style cabinetry, movable kitchen islands, USB outlets, wood-style flooring, and in-home laundry with the practical perks that keep life moving.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find the layout that fits.</strong> The Leila Sweetwater offers one-, two-, and three-bedroom apartments in Lithia Springs with space to compare pricing, availability, beds, and baths at a glance.</p><p>Each home pairs everyday function with elevated finishes, including <strong>granite counters, stainless steel appliances, 42-inch Shaker-style cabinetry, movable kitchen islands, in-home washers and dryers, wood-style flooring, and 9-foot ceilings</strong>.</p>",
  "property_home_gallery_blurb": "<p><strong>Picture life at The Leila Sweetwater.</strong> Preview bright poolside spaces, inviting clubhouse corners, and modern apartment interiors with granite countertops, stainless steel appliances, Shaker-style cabinetry, wood-style flooring, and 9-foot ceilings. From fitness space to one-, two-, and three-bedroom layouts, the gallery gives you a crisp look at what makes this Lithia Springs community stand out.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Map more from Lee Road.</strong> At The Leila Sweetwater, a quieter Douglas County setting keeps you close to Sweetwater Creek State Park’s wooded trails, rocky creek views, mill ruins, and reservoir time. Keep dinner nearby at Tiffany’s Kitchen or The Olive Tree, or head into Douglasville for Arbor Place, Gumbeaux’s, GreyStone Amphitheater, and Town Green events. Explore the map, then see how the neighborhood connects back to home.</p>",
  "property_home_reviews_blurb": "<p><strong>See why The Leila Sweetwater earns standout reviews.</strong> Residents and visitors highlight a beautiful, quiet, modern community that feels polished from the first tour, with well-kept spaces, thoughtful amenities, and convenient access for an easy ATL commute.</p><p>Reviews also spotlight the service, from responsive leasing help to smooth move-in support and warm hospitality from team members like Keisha, Michelle, and Tiara. Read more to see what makes the experience memorable.</p>",
  "property_neighborhood_blurb": "<p><strong>Map your day from Lee Road.</strong> The Leila Sweetwater puts you in a quieter Douglas County setting with quick routes to trailheads, errands, dinner plans, and Atlanta-bound drives. Follow the map to Sweetwater Creek State Park for wooded paths, rocky creek views, mill ruins, and time on George Sparks Reservoir, then keep it local with comfort food at Tiffany’s Kitchen or Mediterranean and Italian favorites at The Olive Tree.</p><p>When you want more to do, Douglasville adds destination dining at Gumbeaux’s, shopping and movies at Arbor Place, and outdoor concerts at the GreyStone Amphitheater and Town Green. Back at home, pair the neighborhood’s easygoing pace with polished spaces and community perks you can preview in the <a href=\"/gallery\">photo gallery</a> or explore during a <a href=\"/schedule-a-tour\">scheduled tour</a>.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities that keep the day moving.</strong> At The Leila Sweetwater, comfort starts in the spaces you use every day: a resort-inspired pool and sun deck for unwinding, a fitness center with free weights for your routine, and a clubhouse that gives you more room to relax beyond your front door.</p><p>Inside your one-, two-, or three-bedroom apartment in Lithia Springs, polished finishes make the difference—granite counters, stainless steel appliances, 42-inch Shaker-style cabinetry, movable kitchen islands, USB outlets, wood-style flooring, and in-home laundry all work together for a clean, practical feel. Controlled access, available garages, a centralized mail hub, and on-site management and service teams add everyday ease. See how it all comes together in the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to explore the amenities in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at The Leila Sweetwater.</strong> Choose a one-, two-, or three-bedroom apartment with polished finishes like granite counters, stainless steel appliances, wood-style flooring, and 9-foot ceilings. Apply online today and move one step closer to modern comfort near Sweetwater Creek.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact The Leila Sweetwater leasing team for details on our one-, two-, and three-bedroom apartments, modern finishes, and connected Lithia Springs location near I-20. Reach out today for answers, directions, or help planning your next visit.</p>",
  "property_faqs_blurb": "<p><strong>Questions about life at The Leila Sweetwater?</strong> Start here for quick answers on the community, leasing, amenities, and everyday details. If you need anything more specific, the on-site leasing team is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the space that works.</strong> Explore one-, two-, and three-bedroom apartments in Lithia Springs with layouts that move from streamlined and easy to generously sized, so you can compare bedrooms, baths, pricing, and availability in one place.</p><p>Inside, each home brings a polished, practical feel: <strong>granite counters, stainless steel appliances, 42-inch Shaker-style cabinetry, movable kitchen islands, in-home washers and dryers, wood-style flooring, and 9-foot ceilings</strong>. Whether you want a simple one-bedroom retreat or extra bedrooms for more flexibility, The Leila Sweetwater makes it easy to narrow your search, check current options, and picture the finish level before you <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_gallery_blurb": "<p><strong>Get a closer look at The Leila Sweetwater.</strong> Browse photos that bring the community into focus, from the bright pool deck and relaxed clubhouse corners to apartment interiors with clean lines and polished finishes. In the kitchens, granite counters, stainless steel appliances, and Shaker-style cabinetry create a crisp backdrop for everyday moments, while wood-style flooring and 9-foot ceilings give living spaces an open, modern feel.</p><p>As you scroll, notice the details that shape the experience: sunny places to unwind, a fitness space ready for your routine, and floor plans that range from efficient one-bedrooms to spacious three-bedroom layouts. Like what you see? Explore the <a href=\"/amenities\">amenities</a>, compare <a href=\"/floor-plans\">available floor plans</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Leila Sweetwater in Lithia Springs in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore what’s nearby.</strong> Use the interactive map to see available apartments at The Leila Sweetwater and get a feel for the area—from Sweetwater Creek outdoor escapes to convenient access toward I-20, Douglasville, and Atlanta’s westside.</p>",
  "property_pets_blurb": "<p><strong>Bring your pets into the rhythm of home.</strong> At The Leila Sweetwater, pet-friendly apartment living feels easy, with space for daily walks, controlled-access grounds, and modern one-, two-, and three-bedroom layouts that make routines feel less cramped. After a morning loop around the community or a quick play break, come back to wood-style flooring, in-home laundry, and open kitchens designed for real everyday use.</p><p>When you want more room to roam, Lithia Springs puts local pet care and off-leash time within easy reach, including a nearby dog park and veterinary services along Lee Road. Review the pet policy details on this page, then explore our <a href=\"/amenities\">community amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how you and your companions can settle in comfortably.</p>",
  "property_referafriend_blurb": "<p><strong>Share life at The Leila Sweetwater.</strong> Invite a friend to discover modern one-, two-, and three-bedroom apartments with polished finishes, relaxing community spaces, and easy access to Lithia Springs’ outdoor beauty. If you love the comfort and connection here, send them our way.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at The Leila Sweetwater.</strong><br>Pay rent, submit maintenance requests, and manage your account in one convenient place—supported by the on-site management and service teams that help keep daily life running smoothly.</p>",
  "property_reviews_blurb": "<p><strong>Hear what makes The Leila Sweetwater stand out.</strong> Reviews point to a community that feels polished, welcoming, and easy to appreciate from the first tour. Visitors describe the property as “beautiful, quiet, modern, and well maintained,” with amenities that add to the everyday experience and a location praised for an easy commute to ATL.</p><p>You’ll also see plenty of appreciation for the people behind the experience. Reviewers call out Keisha, Michelle, and Tiara for professional, responsive service, memorable hospitality, and smooth move-in support. From helpful leasing conversations to thoughtful community touches like visiting food vendors, the feedback reflects a place where service makes a strong impression.</p>",
  "property_created_at": "1789482543691",
  "property_scheduletour_blurb": "<p><strong>See the polished side of Lithia Springs living.</strong> Tour The Leila Sweetwater and step into modern one-, two-, and three-bedroom layouts with granite counters, stainless steel appliances, 9-foot ceilings, and wood-style flooring. Then picture the pool, fitness center, and clubhouse just beyond your door. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to The Leila Sweetwater.</strong><br>Your submission has been received, and the leasing team will follow up soon. In the meantime, imagine modern Lithia Springs living with thoughtfully finished one-, two-, and three-bedroom layouts, contemporary in-home details, and relaxing community spaces minutes from Sweetwater Creek.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk through before you walk in.</strong> Explore The Leila Sweetwater online with immersive apartment and community tours built around the spaces you want to see most. Move through one-, two-, and three-bedroom layouts, including the furnished one-bedroom model, and notice the open kitchens, island seating, wood-style flooring, bright windows, in-home laundry, and clean designer finishes that shape each home.</p><p>Then step into the Cyber Cafe and Fitness Center to preview the community side of daily life in Lithia Springs—from flexible lounge-style space to a workout area with cardio, strength, and free-weight options. After your virtual tour, compare current <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see The Leila Sweetwater in person.</p>",
  "property_copyright": "2026 All Rights Reserved. The Leila Sweetwater",
  "property_seo_title_home": "The Leila Sweetwater |  Apartments in Lithia Springs, GA",
  "property_seo_description_home": "Experience modern living at The Leila Sweetwater in Lithia Springs, GA, featuring luxurious amenities and stylish apartments. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Lithia Springs, GA Apartments for Rent",
  "property_seo_description_floorplans": "Discover comfort at The Leila Sweetwater in Lithia Springs, GA, with stylish one to three-bedroom floor plans tailored to your lifestyle!",
  "property_seo_title_amenities": "Amenities | Lithia Springs, GA Apartments for Rent",
  "property_seo_description_amenities": "Discover resort-style living at The Leila Sweetwater in Lithia Springs! Enjoy modern amenities and a vibrant community—your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Lithia Springs, GA",
  "property_seo_description_gallery": "Experience luxury living at The Leila Sweetwater! With beautiful floor plans and a resort-style pool, your dream home in Lithia Springs awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | The Leila Sweetwater Apartments",
  "property_seo_description_virtualtours": "Step inside The Leila Sweetwater in Lithia Springs, GA! Experience our spacious one, two, and three-bedroom apartments through an immersive virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | The Leila Sweetwater Apartments",
  "property_seo_description_interactivemap": "Discover your ideal apartment at The Leila Sweetwater in Lithia Springs, GA! Explore layouts, pricing, and luxury amenities with our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Lithia Springs, GA",
  "property_seo_description_neighborhood": "Uncover the vibrant community around The Leila Sweetwater in Lithia Springs, GA. Discover local favorites and exciting attractions just beyond your doorstep!",
  "property_seo_title_contact": "Contact Us | The Leila Sweetwater",
  "property_seo_description_contact": "Connect with The Leila Sweetwater in Lithia Springs, GA! Whether it’s one, two, or three bedrooms, your ideal home awaits. Reach out to our leasing team now!",
  "property_seo_title_faqs": "FAQs | Apartments in Lithia Springs, GA",
  "property_seo_description_faqs": "Uncover the answers to your questions at The Leila Sweetwater! From luxurious amenities to floor plans, our FAQs make living in Lithia Springs effortless.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Lithia Springs, GA",
  "property_seo_description_reviews": "Experience life at The Leila Sweetwater in Lithia Springs, GA. See what our residents love about our stunning amenities and vibrant community atmosphere!",
  "property_seo_title_applynow": "Apply Now | Apartments in Lithia Springs, GA",
  "property_seo_description_applynow": "Discover upscale living at The Leila Sweetwater in Lithia Springs, GA, with resort-style amenities and modern floor plans that feel like home.",
  "property_seo_title_residentaccess": "Resident Access | The Leila Sweetwater",
  "property_seo_description_residentaccess": "Access your resident portal at The Leila Sweetwater in Lithia Springs, GA. Pay rent, schedule maintenance, and enjoy a seamless living experience today!",
  "property_seo_title_referafriend": "Refer A Friend | The Leila Sweetwater",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to The Leila Sweetwater in Lithia Springs today and embrace a vibrant community together.",
  "property_seo_title_scheduletour": "Schedule a Tour | The Leila Sweetwater",
  "property_seo_description_scheduletour": "Experience modern living at The Leila Sweetwater in Lithia Springs, GA. Level up your lifestyle—schedule a tour of our vibrant community today!",
  "property_seo_title_privacy": "Privacy Policy | The Leila Sweetwater",
  "property_seo_description_privacy": "Safeguard your peace of mind at The Leila Sweetwater. Learn how we protect your privacy and enjoy serene living in Lithia Springs, GA. View our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | The Leila Sweetwater",
  "property_seo_description_accessibility": "Embrace digital accessibility at The Leila Sweetwater in Lithia Springs, GA. We prioritize inclusion for all residents. Join our welcoming community today!",
  "property_seo_title_sitemap": "Sitemap | The Leila Sweetwater",
  "property_seo_description_sitemap": "Navigate The Leila Sweetwater in Lithia Springs, GA! Our sitemap connects you to your future home and all community offerings with ease. Explore now!",
  "property_seo_title_thankyou": "Thank You | The Leila Sweetwater",
  "property_seo_description_thankyou": "Thank you for reaching out to The Leila Sweetwater! We're excited to help you find your perfect home in Lithia Springs. Stay tuned for our team’s response!",
  "property_seo_title_pets": "Pet Policy | Apartments in Lithia Springs, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1790793472457",
  "amenities": [
    {
      "id": "custom_79e96486-f3a5-447d-9a3f-262bf380df4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑Inspired Swimming Pool with Sun Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_481cbb9f-dcfa-48b4-9f5d-bf283d03a746",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Leasing and Management Team",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67e2d016-e99b-43d1-a729-825e031c3254",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "On‑Site Service Team",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf850c94-c89d-4115-afee-a91a8dbbe010",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f7558fa1-7a92-4953-a5b9-0f98ed20d9bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "State‑of‑the‑Art Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0bc5dbdb-11cc-4e24-b7a7-45c9bb615efe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e338bc1b-051e-4220-a7a7-d0cf896fcf46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cb2ecf5d-5547-414e-a263-5657201e09a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_891b578d-b77e-4826-9d8f-a75143f0cea0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access / Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1f4cb6f5-0968-4968-a7c7-db977e55442f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Centralized Mail Hub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee922511-0fb1-4311-8250-f94cbd67dd48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "PupPlay Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ab6bd6ad-d03d-4db9-a98e-d1660b2ac376",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "AutoSpa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_79530770-4e66-4e0c-a19f-0295cec88415",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Social Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ea7ed6fa-0cdc-4ad2-9183-12df4bfd44ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Fireplace Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe6a425e-a5e4-4753-a86d-e26d8375b5f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Green Spaces and Beautifully Landscaped Courtyards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_add89e22-bb1b-4da5-ac81-ff204fce630f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ad24f9f-0fcc-4896-82e7-2ae9dc09be3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "42\" Shaker‑Style Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81b00f4f-1c4c-403e-b1b6-6e3c211977f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Counters",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_41e6073d-71f8-4caa-9383-29f006754a65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Movable Kitchen Islands",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1a18041b-d343-4e98-a698-76b307dc70a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "USB Outlets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1b7d75d3-6749-49f3-adf1-e43c28b67e91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Garden Tubs",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d544859-f60c-4f0c-8877-9d5a9cbad015",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f20c1d2-4134-4d3b-8415-8e0d10b04103",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "9' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64c1434e-4148-4e54-8493-6bbfa2fac606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec56cb57-41d1-4252-be7e-db03db120ee2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "custom",
      "external_id": "false",
      "title": "Designer Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3c22daab-6262-4b05-8ee9-84c6451c3d50",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-8a38-753e-a79e-5e906faa01f1.webp",
      "image_media": {
        "alt_text": "Modern white building with dark windows and a prominent entrance, surrounded by landscaping and a parking lot.",
        "public_id": "01a0ca67-8a38-753e-a79e-5e906faa01f1",
        "storage_key": "property/6767906449167768/01a0ca67-8a38-753e-a79e-5e906faa01f1.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Discover the inviting atmosphere of our community clubhouse. This modern building features spacious interiors and elegant architecture, perfect for residents to gather and relax.",
      "link": "",
      "alt_text": "Modern white building with dark windows and a prominent entrance, surrounded by landscaping and a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3e72d9d7-4b8f-4946-b6e6-a1f15e5e1909",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-870f-758b-845b-ffbb368b0f1c.webp",
      "image_media": {
        "alt_text": "Gym with weightlifting equipment, cardio machines, and dumbbells",
        "public_id": "01a0ca67-870f-758b-845b-ffbb368b0f1c",
        "storage_key": "property/6767906449167768/01a0ca67-870f-758b-845b-ffbb368b0f1c.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring weight machines, free weights, and cardio equipment for a complete workout experience.",
      "link": "",
      "alt_text": "Gym with weightlifting equipment, cardio machines, and dumbbells",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ef1ac6a6-3164-4d8b-9ee1-0f3d198890d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-8547-7209-b8e3-1a869045def7.webp",
      "image_media": {
        "alt_text": "Slam balls on a rack in a fitness center.",
        "public_id": "01a0ca67-8547-7209-b8e3-1a869045def7",
        "storage_key": "property/6767906449167768/01a0ca67-8547-7209-b8e3-1a869045def7.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Get your workout in at our state-of-the-art fitness center, featuring a variety of weights and equipment for all your training needs.",
      "link": "",
      "alt_text": "Slam balls on a rack in a fitness center.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5340ae67-fa32-4781-b037-2a6383c10337",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-8248-719d-96c8-0be67ebd069a.webp",
      "image_media": {
        "alt_text": "Gym equipment including weight racks, treadmills, and kettlebells.",
        "public_id": "01a0ca67-8248-719d-96c8-0be67ebd069a",
        "storage_key": "property/6767906449167768/01a0ca67-8248-719d-96c8-0be67ebd069a.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a variety of cardio and strength training equipment for residents.",
      "link": "",
      "alt_text": "Gym equipment including weight racks, treadmills, and kettlebells.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_53cf3ee1-29b1-4bbb-8d2b-5664aa6c1dd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-803b-7111-b785-e6e10bbe5cd8.webp",
      "image_media": {
        "alt_text": "Lounge area with comfortable seating, coffee station, and television.",
        "public_id": "01a0ca67-803b-7111-b785-e6e10bbe5cd8",
        "storage_key": "property/6767906449167768/01a0ca67-803b-7111-b785-e6e10bbe5cd8.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting lounge area, featuring comfortable seating, a complimentary coffee station, and entertainment options.",
      "link": "",
      "alt_text": "Lounge area with comfortable seating, coffee station, and television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_863d56d1-03e4-4ba4-9057-ff1538e8367f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-81fb-7654-8ff2-68e8ab57bb46.webp",
      "image_media": {
        "alt_text": "Gym with treadmills and stair climber, large windows looking out onto apartment buildings.",
        "public_id": "01a0ca67-81fb-7654-8ff2-68e8ab57bb46",
        "storage_key": "property/6767906449167768/01a0ca67-81fb-7654-8ff2-68e8ab57bb46.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio equipment like treadmills and stair climbers, with ample natural light from large windows.",
      "link": "",
      "alt_text": "Gym with treadmills and stair climber, large windows looking out onto apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_84751449-f167-4c0e-993a-697d971e014e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-7dff-7112-9cf1-799cfd954c1d.webp",
      "image_media": {
        "alt_text": "Modern seating area with geometric patterned chairs and a round table in a well-lit lobby.",
        "public_id": "01a0ca67-7dff-7112-9cf1-799cfd954c1d",
        "storage_key": "property/6767906449167768/01a0ca67-7dff-7112-9cf1-799cfd954c1d.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating and a contemporary design. Perfect for casual meetings or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Modern seating area with geometric patterned chairs and a round table in a well-lit lobby.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_39b7aea8-406d-4104-a828-e1768c653c37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-7bf2-760b-acd2-dd020a4cbc9e.webp",
      "image_media": {
        "alt_text": "Community lounge area with high-top tables and chairs, featuring a coffee bar and a TV.",
        "public_id": "01a0ca67-7bf2-760b-acd2-dd020a4cbc9e",
        "storage_key": "property/6767906449167768/01a0ca67-7bf2-760b-acd2-dd020a4cbc9e.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Gather in our stylish community lounge, perfect for socializing or working remotely, featuring comfortable seating, a convenient coffee bar, and entertainment options.",
      "link": "",
      "alt_text": "Community lounge area with high-top tables and chairs, featuring a coffee bar and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0d3b3cb5-5677-4d05-84eb-5bfc0af0d428",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-78ad-7208-a3a1-770dab25a8da.webp",
      "image_media": {
        "alt_text": "Modern community lounge area with wood tables and navy chairs.",
        "public_id": "01a0ca67-78ad-7208-a3a1-770dab25a8da",
        "storage_key": "property/6767906449167768/01a0ca67-78ad-7208-a3a1-770dab25a8da.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Gather with friends and neighbors in our stylish community lounge, featuring comfortable seating and elegant decor.",
      "link": "",
      "alt_text": "Modern community lounge area with wood tables and navy chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_abd8743f-f88f-49d7-8b18-95dfd9f15da9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-785a-72b8-81c0-4cac88ca21ae.webp",
      "image_media": {
        "alt_text": "Communal dining area with a large live-edge wood table and seating, lounge area with sofas and chairs, and a mounted television.",
        "public_id": "01a0ca67-785a-72b8-81c0-4cac88ca21ae",
        "storage_key": "property/6767906449167768/01a0ca67-785a-72b8-81c0-4cac88ca21ae.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Enjoy our beautifully designed communal lounge and dining area, perfect for socializing or relaxing. Featuring a large live-edge table, comfortable seating, and modern entertainment.",
      "link": "",
      "alt_text": "Communal dining area with a large live-edge wood table and seating, lounge area with sofas and chairs, and a mounted television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2d5126ac-8aee-48cf-afa3-f9d5ee199f29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-7780-7749-9786-b25730660e52.webp",
      "image_media": {
        "alt_text": "Community kitchen with a wooden table and chairs, sink, and refrigerator.",
        "public_id": "01a0ca67-7780-7749-9786-b25730660e52",
        "storage_key": "property/6767906449167768/01a0ca67-7780-7749-9786-b25730660e52.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Gather around the communal kitchen, perfect for socializing and enjoying snacks. Features a spacious wooden table, modern sink, and a convenient refrigerator.",
      "link": "",
      "alt_text": "Community kitchen with a wooden table and chairs, sink, and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_033e28cb-bc10-4598-ab48-877f326ee011",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-747e-71f8-895a-97649a433544.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a TV, comfortable seating, and a dining table.",
        "public_id": "01a0ca67-747e-71f8-895a-97649a433544",
        "storage_key": "property/6767906449167768/01a0ca67-747e-71f8-895a-97649a433544.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Gather and relax in our stylish resident lounge, featuring a large screen TV, plush seating, and a communal dining space perfect for socializing or working.",
      "link": "",
      "alt_text": "Modern lounge area with a TV, comfortable seating, and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_47ac6122-b451-4aa2-86f7-714fac99af73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-738f-746f-8ad7-07abcd42d635.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with modern furniture, dining tables, and a TV.",
        "public_id": "01a0ca67-738f-746f-8ad7-07abcd42d635",
        "storage_key": "property/6767906449167768/01a0ca67-738f-746f-8ad7-07abcd42d635.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating, dining areas, and a large screen TV.",
      "link": "",
      "alt_text": "Spacious community lounge with modern furniture, dining tables, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7e6bfc6d-75ae-4e45-af2b-63cce7174fb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-67d5-73e7-8ba1-b7c79a442e79.webp",
      "image_media": {
        "alt_text": "An inviting outdoor swimming pool with lounge chairs and cabanas, surrounded by trees and a bright blue sky.",
        "public_id": "01a0ca67-67d5-73e7-8ba1-b7c79a442e79",
        "storage_key": "property/6767906449167768/01a0ca67-67d5-73e7-8ba1-b7c79a442e79.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable lounge areas and shaded cabanas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "An inviting outdoor swimming pool with lounge chairs and cabanas, surrounded by trees and a bright blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab0144f0-4552-4d7a-9ddd-664d5e8ad74e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-6afe-7553-ba83-58f719aa91cb.webp",
      "image_media": {
        "alt_text": "Living room with a navy blue sofa, leather accent chair, coffee table, and desk.",
        "public_id": "01a0ca67-6afe-7553-ba83-58f719aa91cb",
        "storage_key": "property/6767906449167768/01a0ca67-6afe-7553-ba83-58f719aa91cb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable navy blue sofa, a modern accent chair, a marble-top coffee table, and a convenient workspace with a desk and chair.",
      "link": "",
      "alt_text": "Living room with a navy blue sofa, leather accent chair, coffee table, and desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1072227-1dc3-4a8d-b0cb-a68c66034dd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-67aa-712b-93cf-ae98885794a2.webp",
      "image_media": {
        "alt_text": "Covered patio with ping pong table, seating, and outdoor television overlooking a pool.",
        "public_id": "01a0ca67-67aa-712b-93cf-ae98885794a2",
        "storage_key": "property/6767906449167768/01a0ca67-67aa-712b-93cf-ae98885794a2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy fun and games on the covered patio, complete with a ping pong table, comfortable seating, and an outdoor TV, all with a view of the sparkling pool.",
      "link": "",
      "alt_text": "Covered patio with ping pong table, seating, and outdoor television overlooking a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b5425f7d-d6d8-4e7e-9e71-f8e17d862b84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-68fe-7561-b2eb-08dc4175707d.webp",
      "image_media": {
        "alt_text": "Laundry room with washer and dryer",
        "public_id": "01a0ca67-68fe-7561-b2eb-08dc4175707d",
        "storage_key": "property/6767906449167768/01a0ca67-68fe-7561-b2eb-08dc4175707d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "In-unit laundry room with a stacked washer and dryer, plus shelving for supplies.",
      "link": "",
      "alt_text": "Laundry room with washer and dryer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6d86cb0c-3dde-48f9-b840-979e73b6e799",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-68aa-7496-8551-598ee32634dc.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel refrigerator, microwave, sink, and cabinets.",
        "public_id": "01a0ca67-68aa-7496-8551-598ee32634dc",
        "storage_key": "property/6767906449167768/01a0ca67-68aa-7496-8551-598ee32634dc.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Apartment",
      "description": "Experience sleek design and convenience in this modern apartment kitchen, featuring a full suite of stainless steel appliances and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel refrigerator, microwave, sink, and cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6f8ccff4-a4f6-4dd0-b75b-df7ef79693e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-5927-72ad-87d5-c3895cecefa4.webp",
      "image_media": {
        "alt_text": "Covered outdoor lounge area with ping pong table, seating, and a TV, overlooking a pool.",
        "public_id": "01a0ca67-5927-72ad-87d5-c3895cecefa4",
        "storage_key": "property/6767906449167768/01a0ca67-5927-72ad-87d5-c3895cecefa4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy year-round fun in our outdoor lounge, complete with a ping pong table, comfortable seating, and entertainment options, all with a view of the sparkling pool.",
      "link": "",
      "alt_text": "Covered outdoor lounge area with ping pong table, seating, and a TV, overlooking a pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71dcc77b-9926-4140-a02e-34d8385958be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-57ff-72dd-81e6-6c179e8b5fa7.webp",
      "image_media": {
        "alt_text": "Modern gym with cardio machines, weight racks, and mirrors.",
        "public_id": "01a0ca67-57ff-72dd-81e6-6c179e8b5fa7",
        "storage_key": "property/6767906449167768/01a0ca67-57ff-72dd-81e6-6c179e8b5fa7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio equipment, free weights, and strength training machines to help you stay active.",
      "link": "",
      "alt_text": "Modern gym with cardio machines, weight racks, and mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f30fc25-4217-4bfb-bd09-137501fc79b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-5418-7479-bc2c-435acaf695c6.webp",
      "image_media": {
        "alt_text": "Dog park area with agility equipment and fenced enclosure with apartment buildings in the background.",
        "public_id": "01a0ca67-5418-7479-bc2c-435acaf695c6",
        "storage_key": "property/6767906449167768/01a0ca67-5418-7479-bc2c-435acaf695c6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, perfect for your furry friends to run and play. Featuring agility equipment and ample space, it's a great amenity for pet owners.",
      "link": "",
      "alt_text": "Dog park area with agility equipment and fenced enclosure with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6fabf4cb-bfdc-47f4-8d65-ccbb3d13577c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-56d3-752e-b18b-d8907bfb3cb2.webp",
      "image_media": {
        "alt_text": "Modern fitness center with weight racks, treadmills, and exercise equipment.",
        "public_id": "01a0ca67-56d3-752e-b18b-d8907bfb3cb2",
        "storage_key": "property/6767906449167768/01a0ca67-56d3-752e-b18b-d8907bfb3cb2.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with everything you need for a great workout.",
      "link": "",
      "alt_text": "Modern fitness center with weight racks, treadmills, and exercise equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c755ee3e-6f15-4c37-8629-5f2fe37b98c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-469f-77dc-a3ea-5b1e2cbd3bff.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with chairs and a mural on the building.",
        "public_id": "01a0ca67-469f-77dc-a3ea-5b1e2cbd3bff",
        "storage_key": "property/6767906449167768/01a0ca67-469f-77dc-a3ea-5b1e2cbd3bff.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting outdoor seating area, complete with comfortable chairs and a beautiful mural depicting a serene landscape.",
      "link": "",
      "alt_text": "Outdoor seating area with chairs and a mural on the building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5bfec9d6-783d-4e4d-bef7-37d4c92f76ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-44c0-760e-ab34-dacf0dff2c11.webp",
      "image_media": {
        "alt_text": "Outdoor recreational area with artificial turf, cornhole boards, seating, and a covered patio.",
        "public_id": "01a0ca67-44c0-760e-ab34-dacf0dff2c11",
        "storage_key": "property/6767906449167768/01a0ca67-44c0-760e-ab34-dacf0dff2c11.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy outdoor games and relaxation in our community's recreation zone, featuring artificial turf, comfortable seating, and a covered patio area.",
      "link": "",
      "alt_text": "Outdoor recreational area with artificial turf, cornhole boards, seating, and a covered patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3a20381f-9df4-4150-8389-1bd0cf63af7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-434b-707d-a22c-62aecf681a50.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit with seating and hammock.",
        "public_id": "01a0ca67-434b-707d-a22c-62aecf681a50",
        "storage_key": "property/6767906449167768/01a0ca67-434b-707d-a22c-62aecf681a50.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Gather around the fire pit in this inviting outdoor living space, perfect for relaxing and socializing. Includes comfortable seating and a hammock for ultimate comfort.",
      "link": "",
      "alt_text": "Outdoor fire pit with seating and hammock.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9ade7d05-2874-48ef-bba2-5b03c7bf3fbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-43e7-7378-8821-5ba5ec2299c5.webp",
      "image_media": {
        "alt_text": "Outdoor lounge cabana with chairs and hammock",
        "public_id": "01a0ca67-43e7-7378-8821-5ba5ec2299c5",
        "storage_key": "property/6767906449167768/01a0ca67-43e7-7378-8821-5ba5ec2299c5.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax in style in this outdoor cabana, complete with comfortable lounge chairs and a hammock, perfect for enjoying the fresh air.",
      "link": "",
      "alt_text": "Outdoor lounge cabana with chairs and hammock",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4fd47a23-850b-4f45-aeba-3c41fb00cd44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-4018-736d-8cd6-57ab1d3fa731.webp",
      "image_media": {
        "alt_text": "Covered patio with seating and outdoor dining area overlooking the pool.",
        "public_id": "01a0ca67-4018-736d-8cd6-57ab1d3fa731",
        "storage_key": "property/6767906449167768/01a0ca67-4018-736d-8cd6-57ab1d3fa731.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy the outdoors with comfortable seating and dining spaces on the covered patio, adjacent to the sparkling swimming pool.",
      "link": "",
      "alt_text": "Covered patio with seating and outdoor dining area overlooking the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7d546702-cfe1-4b4d-90ba-84adbf78d1a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-34da-7326-9d1a-781b90842f09.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a dual vanity, granite countertops, and a walk-in shower with marble tile.",
        "public_id": "01a0ca67-34da-7326-9d1a-781b90842f09",
        "storage_key": "property/6767906449167768/01a0ca67-34da-7326-9d1a-781b90842f09.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience luxury in this modern bathroom, featuring elegant granite countertops, a spacious dual vanity, and a stylish walk-in shower with marble tile accents.",
      "link": "",
      "alt_text": "Modern bathroom with a dual vanity, granite countertops, and a walk-in shower with marble tile.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc85d78a-706e-469e-9bad-8a7e73ca7ff2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-32c0-70bd-b7f3-417759c5049d.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, navy accent wall with abstract art, and open closet.",
        "public_id": "01a0ca67-32c0-70bd-b7f3-417759c5049d",
        "storage_key": "property/6767906449167768/01a0ca67-32c0-70bd-b7f3-417759c5049d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-size bed, a stylish navy accent wall with abstract art, and a spacious walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, navy accent wall with abstract art, and open closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_003afa06-1865-4a7d-b68d-45745be0b984",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-2fab-75aa-8031-33339abe0065.webp",
      "image_media": {
        "alt_text": "Living room and kitchen of a furnished apartment with a blue sofa, tan armchair, and modern kitchen.",
        "public_id": "01a0ca67-2fab-75aa-8031-33339abe0065",
        "storage_key": "property/6767906449167768/01a0ca67-2fab-75aa-8031-33339abe0065.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a plush blue sofa and a modern, open-concept kitchen with white cabinetry and stainless steel appliances.",
      "link": "",
      "alt_text": "Living room and kitchen of a furnished apartment with a blue sofa, tan armchair, and modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8c9a2b3-0af3-4c42-b6ce-2d4b9aa12822",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-34c8-70e0-8942-4d4323bf8caa.webp",
      "image_media": {
        "alt_text": "Spacious resident lounge with comfortable seating areas, dining tables, and a large TV.",
        "public_id": "01a0ca67-34c8-70e0-8942-4d4323bf8caa",
        "storage_key": "property/6767906449167768/01a0ca67-34c8-70e0-8942-4d4323bf8caa.webp",
        "width": 1200,
        "height": 800
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish resident lounge, featuring ample seating, work-friendly tables, and entertainment options.",
      "link": "",
      "alt_text": "Spacious resident lounge with comfortable seating areas, dining tables, and a large TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_62f72603-6b98-45c2-8e99-f8316bf9fbda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-2fc2-731e-8e17-21bd1c8f6af8.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, blue accent wall with artwork, and a window overlooking trees.",
        "public_id": "01a0ca67-2fc2-731e-8e17-21bd1c8f6af8",
        "storage_key": "property/6767906449167768/01a0ca67-2fc2-731e-8e17-21bd1c8f6af8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a comfortable king-size bed, tasteful artwork, and ample natural light from the large window.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, blue accent wall with artwork, and a window overlooking trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3ace6564-043a-4b97-8ed1-21464c8a0f36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-2205-70af-bf7e-29abeeb36a5e.webp",
      "image_media": {
        "alt_text": "Modern living room with navy sofa, tan accent chair, TV, and large window.",
        "public_id": "01a0ca67-2205-70af-bf7e-29abeeb36a5e",
        "storage_key": "property/6767906449167768/01a0ca67-2205-70af-bf7e-29abeeb36a5e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable navy sofa, a chic accent chair, a mounted television, and a large window with natural light.",
      "link": "",
      "alt_text": "Modern living room with navy sofa, tan accent chair, TV, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e1e7af9-87e2-46a8-99b9-4c9a1a3cf474",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-2583-759f-8758-4901f78040ec.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, subway tile backsplash, stainless steel appliances, and a large island with bar stools.",
        "public_id": "01a0ca67-2583-759f-8758-4901f78040ec",
        "storage_key": "property/6767906449167768/01a0ca67-2583-759f-8758-4901f78040ec.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "View of a stylish apartment kitchen, featuring white cabinetry, a gray subway tile backsplash, and a spacious island with seating, perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, subway tile backsplash, stainless steel appliances, and a large island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_37f5c29c-6f1d-4269-8bcd-bed04d4e1f3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-2207-74af-8245-7cfef434a8e4.webp",
      "image_media": {
        "alt_text": "Modern living room with blue sofa, accent chair, coffee table, and TV.",
        "public_id": "01a0ca67-2207-74af-8245-7cfef434a8e4",
        "storage_key": "property/6767906449167768/01a0ca67-2207-74af-8245-7cfef434a8e4.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and modern living area featuring a comfortable blue sofa, stylish accent chair, and a sleek TV mounted on the wall. The open-concept layout seamlessly connects to the kitchen and dining areas.",
      "link": "",
      "alt_text": "Modern living room with blue sofa, accent chair, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_42c41133-39ae-42f6-aa1a-e08770ab8983",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-21c9-707e-8041-eb5f9046afbf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a0ca67-21c9-707e-8041-eb5f9046afbf",
        "storage_key": "property/6767906449167768/01a0ca67-21c9-707e-8041-eb5f9046afbf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Sleek and modern kitchen featuring white cabinetry, granite countertops, stainless steel appliances, and a spacious island perfect for dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_23baddc4-cfa8-4d58-bffe-14b3c09d831a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-21d3-72e7-8e19-9be925ad066e.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a0ca67-21d3-72e7-8e19-9be925ad066e",
        "storage_key": "property/6767906449167768/01a0ca67-21d3-72e7-8e19-9be925ad066e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Stunning modern kitchen featuring sleek white cabinetry, premium stainless steel appliances, and a spacious island perfect for casual dining or entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and an island with bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_78fdda40-7cf5-41a8-aecd-36490a4aed07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0ca67-10a2-7599-be26-a95f214122fe.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with in-water loungers and lounge chairs.",
        "public_id": "01a0ca67-10a2-7599-be26-a95f214122fe",
        "storage_key": "property/6767906449167768/01a0ca67-10a2-7599-be26-a95f214122fe.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, featuring in-water loungers and ample seating for relaxation.",
      "link": "",
      "alt_text": "Resort-style swimming pool with in-water loungers and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_80bc9f6c-7a66-4375-add1-190b598be88f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-53d0-76cc-96dd-fe4b01ef5f6f.webp",
      "image_media": {
        "alt_text": "Couple assembling furniture in their apartment.",
        "public_id": "01a0cab1-53d0-76cc-96dd-fe4b01ef5f6f",
        "storage_key": "property/6767906449167768/01a0cab1-53d0-76cc-96dd-fe4b01ef5f6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "A couple happily assembles new furniture in their apartment, showcasing a lifestyle of modern living and personal comfort.",
      "link": "",
      "alt_text": "Couple assembling furniture in their apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_120e468b-e457-40b9-af02-b315d2f9e42a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-67b6-7344-81a9-f8d585c2bee4.webp",
      "image_media": {
        "alt_text": "Couple preparing breakfast in a bright, modern kitchen.",
        "public_id": "01a0cab1-67b6-7344-81a9-f8d585c2bee4",
        "storage_key": "property/6767906449167768/01a0cab1-67b6-7344-81a9-f8d585c2bee4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoying a leisurely breakfast together in your stylish apartment kitchen.",
      "link": "",
      "alt_text": "Couple preparing breakfast in a bright, modern kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6e8ae47c-6844-4eb8-b741-18595c73956d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-56ff-7065-a925-b895c7c880da.webp",
      "image_media": {
        "alt_text": "Three friends enjoying wine on a balcony with city view",
        "public_id": "01a0cab1-56ff-7065-a925-b895c7c880da",
        "storage_key": "property/6767906449167768/01a0cab1-56ff-7065-a925-b895c7c880da.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Three friends laugh and enjoy glasses of wine on a balcony, with a city skyline in the background. Perfect for showcasing resident social life and apartment amenities.",
      "link": "",
      "alt_text": "Three friends enjoying wine on a balcony with city view",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c891d9af-e16a-4010-93d0-e6ca4fd36df2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-6635-760b-82e9-148b8b3cff25.webp",
      "image_media": {
        "alt_text": "Two women smiling and holding a baby.",
        "public_id": "01a0cab1-6635-760b-82e9-148b8b3cff25",
        "storage_key": "property/6767906449167768/01a0cab1-6635-760b-82e9-148b8b3cff25.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "A happy family enjoying their time together in their apartment home. Love and laughter fill the air.",
      "link": "",
      "alt_text": "Two women smiling and holding a baby.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ae4f4a4f-48e3-41f9-b55a-e6104460c35e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-643c-71fc-90c6-621e9b9383d6.webp",
      "image_media": {
        "alt_text": "A happy family laughing and playing together on a couch.",
        "public_id": "01a0cab1-643c-71fc-90c6-621e9b9383d6",
        "storage_key": "property/6767906449167768/01a0cab1-643c-71fc-90c6-621e9b9383d6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Create lasting memories with your loved ones in a comfortable and welcoming home environment. This image captures the joy and warmth of family life.",
      "link": "",
      "alt_text": "A happy family laughing and playing together on a couch.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_061897a5-99e6-4439-afbf-b9833a613980",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-65d6-7659-89a5-d2315fb09dfc.webp",
      "image_media": {
        "alt_text": "People socializing and enjoying a barbecue in a grassy outdoor area with string lights and colorful flags.",
        "public_id": "01a0cab1-65d6-7659-89a5-d2315fb09dfc",
        "storage_key": "property/6767906449167768/01a0cab1-65d6-7659-89a5-d2315fb09dfc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Lifestyle",
      "description": "Enjoy a vibrant community atmosphere with friends and neighbors at our outdoor barbecue events, perfect for making lasting memories.",
      "link": "",
      "alt_text": "People socializing and enjoying a barbecue in a grassy outdoor area with string lights and colorful flags.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_258efdbb-7ec5-479b-a804-cceaf434ee14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-5813-71ed-988c-a21e3cf80c18.webp",
      "image_media": {
        "alt_text": "A man and a woman stretching outdoors, both with prosthetic legs.",
        "public_id": "01a0cab1-5813-71ed-988c-a21e3cf80c18",
        "storage_key": "property/6767906449167768/01a0cab1-5813-71ed-988c-a21e3cf80c18.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "Active individuals enjoying an outdoor workout session, highlighting inclusivity and a healthy lifestyle.",
      "link": "",
      "alt_text": "A man and a woman stretching outdoors, both with prosthetic legs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d3483b05-f905-4dd0-ac8a-41bb622dd27b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-6507-770e-8aa8-b4b138803677.webp",
      "image_media": {
        "alt_text": "Woman tying her running shoes outdoors, smiling.",
        "public_id": "01a0cab1-6507-770e-8aa8-b4b138803677",
        "storage_key": "property/6767906449167768/01a0cab1-6507-770e-8aa8-b4b138803677.webp",
        "width": 3072,
        "height": 2040
      },
      "title": "Lifestyle",
      "description": "Active woman taking a break to tie her running shoes. Enjoy an active lifestyle with our community amenities.",
      "link": "",
      "alt_text": "Woman tying her running shoes outdoors, smiling.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d4666684-f600-4caf-bc15-15ed00758cda",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-5353-7599-8255-141279eaebd2.webp",
      "image_media": {
        "alt_text": "Two men petting their dog in a bright living room.",
        "public_id": "01a0cab1-5353-7599-8255-141279eaebd2",
        "storage_key": "property/6767906449167768/01a0cab1-5353-7599-8255-141279eaebd2.webp",
        "width": 3072,
        "height": 1296
      },
      "title": "Lifestyle",
      "description": "Enjoying quality time with your furry friend in a spacious and comfortable living area.",
      "link": "",
      "alt_text": "Two men petting their dog in a bright living room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_92cfef87-5597-419a-b7f0-e6e0170d1ddd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0cab1-55b5-73dd-b0c9-eaa039959b5d.webp",
      "image_media": {
        "alt_text": "Man with Down syndrome laughing at dinner table with family.",
        "public_id": "01a0cab1-55b5-73dd-b0c9-eaa039959b5d",
        "storage_key": "property/6767906449167768/01a0cab1-55b5-73dd-b0c9-eaa039959b5d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Lifestyle",
      "description": "A joyful family meal with a man who has Down syndrome laughing heartily as he shares dinner with loved ones. This image evokes warmth, connection, and inclusivity.",
      "link": "",
      "alt_text": "Man with Down syndrome laughing at dinner table with family.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_52d31f974c926b6975f81050",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "The Olive Tree Restaurant - Lithia Springs",
      "poi_type": "Restaurants",
      "poi_address": "849 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Unpretentious venue providing a mix of Greek & Italian dishes, from lasagna to gyros.",
      "poi_long_description": "Unpretentious venue providing a mix of Greek & Italian dishes, from lasagna to gyros.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-755c-7778-9c50-6993b1ba3a2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-755c-7778-9c50-6993b1ba3a2b",
        "storage_key": "property/6767906449167768/01a0a57b-755c-7778-9c50-6993b1ba3a2b.webp",
        "width": 1066,
        "height": 795
      },
      "poi_business_url": "https://www.theolivetreelithiasprings.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17005808321176476600&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-olive-tree-restaurant---lithia-springs",
      "poi_latitude": "33.7812511",
      "poi_longitude": "-84.60908169999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-948-1288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-ZXFow4i9YgRuBsbRpHEAOw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c58644a25c7500dba855a908",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Contreju Jamaican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "639 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Jamaican dishes such as jerk chicken and curry goat served in an unpretentious setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-7684-76d8-8a6a-0ac5af3c40da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-7684-76d8-8a6a-0ac5af3c40da",
        "storage_key": "property/6767906449167768/01a0a57b-7684-76d8-8a6a-0ac5af3c40da.webp",
        "width": 1178,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5358170215707187668&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "contreju-jamaican-restaurant",
      "poi_latitude": "33.7869142",
      "poi_longitude": "-84.61934160000001",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-944-4221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGf5vtxMi9YgR1BlOIWwLXEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_904c55ff04162cf7e9b0a302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "La Fiesta Mexican Thornton Rd.",
      "poi_type": "Restaurants",
      "poi_address": "1102 Thornton Rd Suite-E, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Casual eatery focusing on familiar Mexican fare, such as fajitas and tacos.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-7690-73b0-b827-582da0d42bb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-7690-73b0-b827-582da0d42bb2",
        "storage_key": "property/6767906449167768/01a0a57b-7690-73b0-b827-582da0d42bb2.webp",
        "width": 590,
        "height": 806
      },
      "poi_business_url": "http://www.lafiestamexicanthornton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3526165954731867061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fiesta-mexican-thornton-rd",
      "poi_latitude": "33.7725558",
      "poi_longitude": "-84.6023867",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-732-9911",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4xErOSkZ9YgRtXve3kB17zA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_1cfec7e85d2d7983acf9a5a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "970 W Pointe Ct, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_long_description": "Homey chain restaurant serving American comfort food, with an on-site general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-b730-7370-a8c8-bccf54b44f5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-b730-7370-a8c8-bccf54b44f5f",
        "storage_key": "property/6767906449167768/01a0a578-b730-7370-a8c8-bccf54b44f5f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/locations/states/ga/lithia-springs/543",
      "poi_directions_map_url": "https://maps.google.com/?cid=14550607236029033162&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "33.7745722",
      "poi_longitude": "-84.60584039999999",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-398-8568",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1Iw4qkY9YgRyiq9UTAk7sk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_36800bbb6927c5dcc91b7bb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Fred's Bar-B-Q House",
      "poi_type": "Restaurants",
      "poi_address": "541 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Long-running, unpretentious eatery offering BBQ plates, sandwiches & more, plus a drive-thru option.",
      "poi_long_description": "Long-running, unpretentious eatery offering BBQ plates, sandwiches & more, plus a drive-thru option.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-7505-713f-ae71-93bca636d837.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-7505-713f-ae71-93bca636d837",
        "storage_key": "property/6767906449167768/01a0a57b-7505-713f-ae71-93bca636d837.webp",
        "width": 1178,
        "height": 682
      },
      "poi_business_url": "http://fredsbbqhouse.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1394487041940349616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freds-bar-b-q-house",
      "poi_latitude": "33.7902321",
      "poi_longitude": "-84.6269786",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-941-1155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYfqa4T8i9YgRsGK9ipM2WhM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_c4b0c2690619c97bf1ff57bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Applebee's Grill + Bar",
      "poi_type": "Restaurants",
      "poi_address": "550 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_long_description": "Full-service chain bar & grill providing hearty American eats in an informal setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-786e-7072-bc67-ac78e4c53196.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-786e-7072-bc67-ac78e4c53196",
        "storage_key": "property/6767906449167768/01a0a57b-786e-7072-bc67-ac78e4c53196.webp",
        "width": 1280,
        "height": 828
      },
      "poi_business_url": "https://restaurants.applebees.com/en-us/ga/lithia-springs/550-thornton-road-98011?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=98011&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=404445969562786616&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "applebees-grill--bar",
      "poi_latitude": "33.7905314",
      "poi_longitude": "-84.624587",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-398-0888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXobJhUi9YgRONuganfhnAU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_1a063a69ad863ec3211d88d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Johnny's New York Style Pizza",
      "poi_type": "Restaurants",
      "poi_address": "230 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Family-friendly pizza chain with New York-style pies, submarine sandwiches & calzones.",
      "poi_long_description": "Family-friendly pizza chain with New York-style pies, submarine sandwiches & calzones.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-7697-74e1-a91d-7fd4d8d130fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-7697-74e1-a91d-7fd4d8d130fa",
        "storage_key": "property/6767906449167768/01a0a57b-7697-74e1-a91d-7fd4d8d130fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://johnnyspizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9960529110516500933&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnnys-new-york-style-pizza",
      "poi_latitude": "33.7947291",
      "poi_longitude": "-84.6351181",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-745-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgbF3VEYi9YgRxQlG73PoOoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_7b95bf1de2a4a34c6531c184",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "New China Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "622 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Fried rice, egg rolls, lo mein & other familiar eats are featured at this informal Chinese joint.",
      "poi_long_description": "Fried rice, egg rolls, lo mein & other familiar eats are featured at this informal Chinese joint.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-76fe-722c-aff7-0038c88a2c57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-76fe-722c-aff7-0038c88a2c57",
        "storage_key": "property/6767906449167768/01a0a57b-76fe-722c-aff7-0038c88a2c57.webp",
        "width": 1280,
        "height": 641
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10802581501562178176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-china-restaurant",
      "poi_latitude": "33.789881",
      "poi_longitude": "-84.62076900000001",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-739-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd4DahBQi9YgRgMrRIaR66pU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_e54ce8784813ff552382d968",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Ellianos Coffee Co",
      "poi_type": "Restaurants",
      "poi_address": "2605 Lee Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Drive-thru chain doling out coffee & espresso drinks along with breakfast sandwiches & baked goods.",
      "poi_long_description": "Drive-thru chain doling out coffee & espresso drinks along with breakfast sandwiches & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-7823-7618-a5d8-c69f7c7adbdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-7823-7618-a5d8-c69f7c7adbdd",
        "storage_key": "property/6767906449167768/01a0a57b-7823-7618-a5d8-c69f7c7adbdd.webp",
        "width": 1280,
        "height": 1114
      },
      "poi_business_url": "http://ellianos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17517822966032407345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ellianos-coffee-co",
      "poi_latitude": "33.7355268",
      "poi_longitude": "-84.66755739999999",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-847-7449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c966-745b-8d0c-b0fc2bd5f8fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c966-745b-8d0c-b0fc2bd5f8fa",
        "storage_key": "property/6767906449167768/01a0a57b-c966-745b-8d0c-b0fc2bd5f8fa.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJy_1VkOch9YgRMZuKmCzPG_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "ec_9160f5bbfd0777172f6ad5af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Tiffany's Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "7413 Lee Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Casual, kid-friendly restaurant specializing in traditional American eats, such as hamburgers, biscuits, waffles and country-fried steak.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-750f-7561-a182-7bb7ef13e016.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-750f-7561-a182-7bb7ef13e016",
        "storage_key": "property/6767906449167768/01a0a57b-750f-7561-a182-7bb7ef13e016.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tiffanyskitchenga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1178131353156268092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tiffanys-kitchen",
      "poi_latitude": "33.7745263",
      "poi_longitude": "-84.653677",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 678-398-8446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0WmNltYj9YgRPDChQzmQWRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_beba2640bccbcb972aaec724",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Papa Johns Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2725 Lee Rd Ste B - 5, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Pizza take-out & delivery chain offering classic & specialty pizzas, plus wings, sides & desserts.",
      "poi_long_description": "Pizza take-out & delivery chain offering classic & specialty pizzas, plus wings, sides & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-7cd6-74f3-87c7-45b7289f5d54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-7cd6-74f3-87c7-45b7289f5d54",
        "storage_key": "property/6767906449167768/01a0a57b-7cd6-74f3-87c7-45b7289f5d54.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.papajohns.com/united-states/ga/30122/lithia-springs/2725-lee-road?utm_source=gmb&utm_medium=organic&y_source=1_MTA2OTI4NzktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17042158383806266571&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "papa-johns-pizza",
      "poi_latitude": "33.7348191",
      "poi_longitude": "-84.6692195",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-947-0011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI93CChQh9YgRy7y3wMHogew",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_c006ddb166ecfaa6d37f4396",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Taqueria Don Claudio",
      "poi_type": "Restaurants",
      "poi_address": "6945 S Sweetwater Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Cozy Mexican spot featuring favorites such as birria tacos and carne asada.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-7ee6-74cc-bc26-b147003a9bc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-7ee6-74cc-bc26-b147003a9bc0",
        "storage_key": "property/6767906449167768/01a0a57b-7ee6-74cc-bc26-b147003a9bc0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=17154374112655977560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-don-claudio",
      "poi_latitude": "33.785727",
      "poi_longitude": "-84.65680119999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-426-7146",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm7w1PM8j9YgRWCwEIV6UEO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_e40330425c35373ce85ac670",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Beaver Creek Biscuit Company and Barbecue",
      "poi_type": "Restaurants",
      "poi_address": "1451 Six Flags Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Ample plates of ribs & other BBQ standards plus biscuits draw crowds to this down-home spot.",
      "poi_long_description": "Ample plates of ribs & other BBQ standards plus biscuits draw crowds to this down-home spot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-809b-7270-b2f1-87d1596b6372.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-809b-7270-b2f1-87d1596b6372",
        "storage_key": "property/6767906449167768/01a0a57b-809b-7270-b2f1-87d1596b6372.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://beavercreekbbq.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17960394007171903537&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaver-creek-biscuit-company-and-barbecue",
      "poi_latitude": "33.7648013",
      "poi_longitude": "-84.5958378",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-739-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsXelfVIf9YgRMTCJ9zAjQPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "ec_218425035bf3403892ee9b27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Tienda El Ejido 2 (Pupuseria Y Taqueria )",
      "poi_type": "Restaurants",
      "poi_address": "1754 Lee Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-80c2-7298-a317-234b12f41ef3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-80c2-7298-a317-234b12f41ef3",
        "storage_key": "property/6767906449167768/01a0a57b-80c2-7298-a317-234b12f41ef3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tiendaelejido2.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15556235933735562575&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tienda-el-ejido-2-pupuseria-y-taqueria-",
      "poi_latitude": "33.7572926",
      "poi_longitude": "-84.6514321",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 678-402-7078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf3jREqUh9YgRT615SCna4tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_0c046f8ab8fed2f252933e31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "J. Buffalo's House",
      "poi_type": "Restaurants",
      "poi_address": "639 Thornton Rd #113, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Compact fast-food joint offering spicy wings, subs, gyros & fried rice in a strip-mall setting.",
      "poi_long_description": "Compact fast-food joint offering spicy wings, subs, gyros & fried rice in a strip-mall setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-83d0-7678-a6dc-12ff77a2180b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-83d0-7678-a6dc-12ff77a2180b",
        "storage_key": "property/6767906449167768/01a0a57b-83d0-7678-a6dc-12ff77a2180b.webp",
        "width": 1206,
        "height": 666
      },
      "poi_business_url": "https://jbuffaloshouse4.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13775470976590158791&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "j-buffalos-house",
      "poi_latitude": "33.7870703",
      "poi_longitude": "-84.61972469999999",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-941-9410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e500-755e-9e3d-66f331888eb3",
        "storage_key": "property/6767906449167768/01a0a578-e500-755e-9e3d-66f331888eb3.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP5istRMi9YgRxxtcHd5NLL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_eedfb4ace75f224bc4c5d35b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "630 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-810f-73c5-b918-6e9814ab6c5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-810f-73c5-b918-6e9814ab6c5a",
        "storage_key": "property/6767906449167768/01a0a57b-810f-73c5-b918-6e9814ab6c5a.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/lithia-springs/westfork/011/00376?cid=loc_01100376_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095623514751617395&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "33.789797",
      "poi_longitude": "-84.6199788",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-732-6999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e50f-705e-b678-7921e857763e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e50f-705e-b678-7921e857763e",
        "storage_key": "property/6767906449167768/01a0a578-e50f-705e-b678-7921e857763e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqdCihBQi9YgRc8kdcy_d9So",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_ef9b526e2624c560c682cf61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1100 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Department store stocking a wide variety of goods, from groceries and clothing to electronics and furniture.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-82a2-75e6-95f9-36149a172142.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-82a2-75e6-95f9-36149a172142",
        "storage_key": "property/6767906449167768/01a0a57b-82a2-75e6-95f9-36149a172142.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3205-lithia-springs-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=670555154343775661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.7745844",
      "poi_longitude": "-84.6011365",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-819-1123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e526-711f-a172-773c1fe4b1e8",
        "storage_key": "property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgzVYZrgj9YgRrc33MFxKTgk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_ef52eb7d85b6fc398d5afd34",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Publix Super Market at Paradise Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "2675 Lee Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-b8e3-7079-a9f3-707a1e37bbbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-b8e3-7079-a9f3-707a1e37bbbf",
        "storage_key": "property/6767906449167768/01a0a578-b8e3-7079-a9f3-707a1e37bbbf.webp",
        "width": 768,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=730&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=12589170373325593169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-paradise-crossing",
      "poi_latitude": "33.7353303",
      "poi_longitude": "-84.6688539",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-920-3471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e50f-705e-b678-7921e857763e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e50f-705e-b678-7921e857763e",
        "storage_key": "property/6767906449167768/01a0a578-e50f-705e-b678-7921e857763e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkx3DChQh9YgRUZrxFsG3ta4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "ec_cb579658b67f7d95b2650b37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "590 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-8489-7668-81f7-2d79c92888b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-8489-7668-81f7-2d79c92888b8",
        "storage_key": "property/6767906449167768/01a0a57b-8489-7668-81f7-2d79c92888b8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-590+thornton+rd-lithia+springs-ga-30122/id=7337",
      "poi_directions_map_url": "https://maps.google.com/?cid=5081401577150243142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "33.7897877",
      "poi_longitude": "-84.6228817",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-945-1640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpTOn7BQi9YgRRmEm38_DhEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_252c04b5d3f8165dc9147799",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Lithia Springs Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6935 S Sweetwater Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-8458-70be-9a05-ed0ff17a7cb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-8458-70be-9a05-ed0ff17a7cb5",
        "storage_key": "property/6767906449167768/01a0a57b-8458-70be-9a05-ed0ff17a7cb5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lithiaspringspharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10387262156698840404&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lithia-springs-pharmacy",
      "poi_latitude": "33.7862908",
      "poi_longitude": "-84.656829",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-948-5208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c944-7705-8b2b-5d6727f9d50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c944-7705-8b2b-5d6727f9d50d",
        "storage_key": "property/6767906449167768/01a0a57b-c944-7705-8b2b-5d6727f9d50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsX1GOM8j9YgRVG3kvuX3JpA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_171f93a48468dfdcdc41da95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1000 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-bb54-7319-acef-bbb1c1af3790.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-bb54-7319-acef-bbb1c1af3790",
        "storage_key": "property/6767906449167768/01a0a578-bb54-7319-acef-bbb1c1af3790.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/Lithia-Spgs-Thornton-Rd/GA/Lithia-Springs/30122/6941?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8496950718607151784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "33.7788577",
      "poi_longitude": "-84.6105877",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-732-0184",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e526-711f-a172-773c1fe4b1e8",
        "storage_key": "property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDY8tFAYi9YgRqFKU6Kg763U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "ec_c043d953bcf2434c8bfb222c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "6660 S Sweetwater Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-b16f-725b-b5ae-e6ae483b5543.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-b16f-725b-b5ae-e6ae483b5543",
        "storage_key": "property/6767906449167768/01a0a57b-b16f-725b-b5ae-e6ae483b5543.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ga/lithia-springs/13728",
      "poi_directions_map_url": "https://maps.google.com/?cid=3922752334652332095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "33.7931009",
      "poi_longitude": "-84.65980479999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-531-0422",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e526-711f-a172-773c1fe4b1e8",
        "storage_key": "property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJCb_sdLgj9YgRP1jJ-HZqcDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_3b9a7e69b2bdc7e7031fd3cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "2682 Lee Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-884f-7068-9b9c-864444d5aa9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-884f-7068-9b9c-864444d5aa9f",
        "storage_key": "property/6767906449167768/01a0a57b-884f-7068-9b9c-864444d5aa9f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/ga/lithia-springs/2682-lee-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9955913082042689402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "33.7332408",
      "poi_longitude": "-84.6674896",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 470-632-4014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e526-711f-a172-773c1fe4b1e8",
        "storage_key": "property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJJ1Yyvhgh9YgReqfRDTOCKoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_80572d3f37d98adff1202c70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "900 Thornton Rd Ste F, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-8824-7619-8188-72d7ec058c81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-8824-7619-8188-72d7ec058c81",
        "storage_key": "property/6767906449167768/01a0a57b-8824-7619-8188-72d7ec058c81.webp",
        "width": 591,
        "height": 1280
      },
      "poi_business_url": "https://locations.dollartree.com/ga/lithia-springs/900-thornton-rd-suite-e",
      "poi_directions_map_url": "https://maps.google.com/?cid=10617425475868358244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "33.7804387",
      "poi_longitude": "-84.6061675",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 470-531-7801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e526-711f-a172-773c1fe4b1e8",
        "storage_key": "property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJycxAdwAj9YgRZPZQfjesWJM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_b4a339dd9c18f5799975c1e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Petes Convenience Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "1870 Lee Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-8bbc-744e-a1ce-d0660fb40435.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-8bbc-744e-a1ce-d0660fb40435",
        "storage_key": "property/6767906449167768/01a0a57b-8bbc-744e-a1ce-d0660fb40435.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14482542187022867372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petes-convenience-store",
      "poi_latitude": "33.7545406",
      "poi_longitude": "-84.65336529999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-944-9097",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c944-7705-8b2b-58abf17a249a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c944-7705-8b2b-58abf17a249a",
        "storage_key": "property/6767906449167768/01a0a57b-c944-7705-8b2b-58abf17a249a.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ62LmSHEh9YgRrFsbJmNT_Mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_bd1b927f47134b43afda203f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Sweetwater Elementary School",
      "poi_type": "Education",
      "poi_address": "2505 E County Line Rd #2714, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-8d3c-7139-8074-981b702a4c3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-8d3c-7139-8074-981b702a4c3a",
        "storage_key": "property/6767906449167768/01a0a57b-8d3c-7139-8074-981b702a4c3a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://swes.dcssga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9900869429118733624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweetwater-elementary-school",
      "poi_latitude": "33.7530702",
      "poi_longitude": "-84.65729449999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-651-4600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLUO4qG4h9YgROI0l6kn0Zok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_fc3a91b30fcd3d0b24b11781",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Lithia Springs High School",
      "poi_type": "Education",
      "poi_address": "2520 E County Line Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-8b39-7319-bfba-df7ed46361d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-8b39-7319-bfba-df7ed46361d1",
        "storage_key": "property/6767906449167768/01a0a57b-8b39-7319-bfba-df7ed46361d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lshs.dcssga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8063757861384043452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lithia-springs-high-school",
      "poi_latitude": "33.7555711",
      "poi_longitude": "-84.65786299999999",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-651-6700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpycC0XEh9YgRvDuPIg056G8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_2866ac529b431204e420d0a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Factory Shoals Middle School",
      "poi_type": "Education",
      "poi_address": "3301 Veterans Park Academy School Rd, Douglasville, GA 30135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-8c8a-73e5-8fba-9add4682b8de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-8c8a-73e5-8fba-9add4682b8de",
        "storage_key": "property/6767906449167768/01a0a57b-8c8a-73e5-8fba-9add4682b8de.webp",
        "width": 650,
        "height": 433
      },
      "poi_business_url": "https://fsms.dcssga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4927780758922872413&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "factory-shoals-middle-school",
      "poi_latitude": "33.7231216",
      "poi_longitude": "-84.6506691",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-651-5800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb1C6qP0g9YgRXUaa4n3-YkQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_11368db4b5a896ad44845eed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Factory Shoals Elementary School",
      "poi_type": "Education",
      "poi_address": "2375 Mt Vernon Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-8cdd-70cb-add4-a5762a581dd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-8cdd-70cb-add4-a5762a581dd2",
        "storage_key": "property/6767906449167768/01a0a57b-8cdd-70cb-add4-a5762a581dd2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://fses.dcssga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11116132813730826696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "factory-shoals-elementary-school",
      "poi_latitude": "33.7421647",
      "poi_longitude": "-84.6502829",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-651-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ15durfwg9YgRyEl99uVvRJo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_c7b481eade25fe968cee2c5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Lithia Springs Elementary School",
      "poi_type": "Education",
      "poi_address": "6946 Florence Dr #1933, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-8dfe-7516-bd0c-adcb0ad531a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-8dfe-7516-bd0c-adcb0ad531a5",
        "storage_key": "property/6767906449167768/01a0a57b-8dfe-7516-bd0c-adcb0ad531a5.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "https://lses.dcssga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3921938645415655735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lithia-springs-elementary-school",
      "poi_latitude": "33.786175",
      "poi_longitude": "-84.66095589999999",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-651-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXaSu1sUj9YgRN3ngLmuGbTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_8f18152e4233c6d3ebaeaa13",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Annette Winn Elementary School",
      "poi_type": "Education",
      "poi_address": "10521 Veterans Memorial Hwy, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-8fe5-75cd-97a9-60e89a6a9c19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-8fe5-75cd-97a9-60e89a6a9c19",
        "storage_key": "property/6767906449167768/01a0a57b-8fe5-75cd-97a9-60e89a6a9c19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://awes.dcssga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9770722309286881845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "annette-winn-elementary-school",
      "poi_latitude": "33.7958353",
      "poi_longitude": "-84.6571286",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-651-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXyelcLcj9YgRNWoHPCyUmIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_2febc8457243d244fb0eef23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "La Petite Academy of Lithia Springs",
      "poi_type": "Education",
      "poi_address": "1806 Lee Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-90f4-75fe-9af9-9bff8347e43d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-90f4-75fe-9af9-9bff8347e43d",
        "storage_key": "property/6767906449167768/01a0a57b-90f4-75fe-9af9-9bff8347e43d.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.lapetite.com/your-local-school/lithia-springs-ga-7415/?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=7415",
      "poi_directions_map_url": "https://maps.google.com/?cid=1449832795049214698&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-petite-academy-of-lithia-springs",
      "poi_latitude": "33.7563164",
      "poi_longitude": "-84.6520515",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 877-271-6466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBX7oIHch9YgR6sKe3D7XHhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_b8fe391f7792c6290ce3d809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Harmony Learning Academy",
      "poi_type": "Education",
      "poi_address": "6746 Tralee Dr, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-942b-73e8-9cde-c30745979891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-942b-73e8-9cde-c30745979891",
        "storage_key": "property/6767906449167768/01a0a57b-942b-73e8-9cde-c30745979891.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.harmonylearningacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6362828528206176941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harmony-learning-academy",
      "poi_latitude": "33.791011",
      "poi_longitude": "-84.6845841",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-948-7270",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl7dogPMj9YgRrWJzrtVOTVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_f1e57dec1f7424c765d7369e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Peerless Learning & Development Childcare Center, LLC",
      "poi_type": "Education",
      "poi_address": "690 Thornton Way Ste D, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-9551-73c9-b88b-db0789237f53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-9551-73c9-b88b-db0789237f53",
        "storage_key": "property/6767906449167768/01a0a57b-9551-73c9-b88b-db0789237f53.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://peerlesschildcarecenterllc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2947081376565950113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peerless-learning--development-childcare-center-llc",
      "poi_latitude": "33.7845546",
      "poi_longitude": "-84.6152469",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-450-8755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8Jr8Ij9YgRofZhzuUi5ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_4ef0578ab05a65acbc126030",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Mercer University Douglas",
      "poi_type": "Education",
      "poi_address": "975 Blairs Bridge Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-94a4-740f-8ee2-78757a9c9724.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-94a4-740f-8ee2-78757a9c9724",
        "storage_key": "property/6767906449167768/01a0a57b-94a4-740f-8ee2-78757a9c9724.webp",
        "width": 580,
        "height": 470
      },
      "poi_business_url": "http://www.mercer.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11995833887675740299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercer-university-douglas",
      "poi_latitude": "33.7710307",
      "poi_longitude": "-84.6058894",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-547-6200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFVf3gKoY9YgRi3CBO13DeaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_19be39b53c7bfb4e5d6386d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Sweetwater Creek State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1750 Mt Vernon Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Historical wooded state park offering hiking, picnicking & boating, plus fishing.",
      "poi_long_description": "Historical wooded state park offering hiking, picnicking & boating, plus fishing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-d14e-77e4-8cff-0fc1c605c242.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-d14e-77e4-8cff-0fc1c605c242",
        "storage_key": "property/6767906449167768/01a0a578-d14e-77e4-8cff-0fc1c605c242.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://gastateparks.org/SweetwaterCreek",
      "poi_directions_map_url": "https://maps.google.com/?cid=11828929759375328263&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweetwater-creek-state-park",
      "poi_latitude": "33.7525384",
      "poi_longitude": "-84.628709",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-732-5871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e530-74ad-bbd5-c9dda275a06b",
        "storage_key": "property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm07D0ZQi9YgRBwSdnPHMKKQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "ec_da3824438e609a9fd27f903d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Lithia Springs Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2922 S Sweetwater Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Laid-back park featuring a playground with swings and baseball fields.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-97d2-7117-8e81-3b50c3d2ee84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-97d2-7117-8e81-3b50c3d2ee84",
        "storage_key": "property/6767906449167768/01a0a57b-97d2-7117-8e81-3b50c3d2ee84.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14458590957561086950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lithia-springs-park",
      "poi_latitude": "33.7728735",
      "poi_longitude": "-84.6403472",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-920-7129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e530-74ad-bbd5-c9dda275a06b",
        "storage_key": "property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ22774Qh9YgR5oMa-t47p8g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1e3767cba4e67454705a7ca0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Containment Haunted House",
      "poi_type": "Entertainment",
      "poi_address": "593 Holly Springs Rd, Rockmart, GA 30153, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-9729-7188-9ae3-004bb6d96e25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-9729-7188-9ae3-004bb6d96e25",
        "storage_key": "property/6767906449167768/01a0a57b-9729-7188-9ae3-004bb6d96e25.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://containmenthaunt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1373450178369884407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "containment-haunted-house",
      "poi_latitude": "33.9150694",
      "poi_longitude": "-85.0123893",
      "poi_miles_from_property": "28.4 mi",
      "poi_walking_minutes": "10 hours 30 mins",
      "poi_biking_minutes": "3 hours 10 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "+1 770-630-8259",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ759DMbLNiogR9xBvDql5DxM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_cd757d170c7bcfef47de73f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Gelly Ball of Atlanta",
      "poi_type": "Entertainment",
      "poi_address": "11400 Veterans Memorial Hwy, Douglasville, GA 30134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-9623-7102-bf92-98e8195b32a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-9623-7102-bf92-98e8195b32a0",
        "storage_key": "property/6767906449167768/01a0a57b-9623-7102-bf92-98e8195b32a0.webp",
        "width": 775,
        "height": 663
      },
      "poi_business_url": "http://gellyballatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8706261327516929406&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gelly-ball-of-atlanta",
      "poi_latitude": "33.7843188",
      "poi_longitude": "-84.7022088",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-635-5334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQEzXEAl9YgRfg1etIza0ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "paintball_center"
    },
    {
      "id": "ec_7d5707987bf6b006cd622af7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Regal Arbor Place",
      "poi_type": "Entertainment",
      "poi_address": "6600 Douglas Blvd, Douglasville, GA 30135, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-98db-72ff-b4bf-fd1c8cf99b0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-98db-72ff-b4bf-fd1c8cf99b0b",
        "storage_key": "property/6767906449167768/01a0a57b-98db-72ff-b4bf-fd1c8cf99b0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-arbor-place-0392?utm_campaign=gmb-listing&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=3801243742323145195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-arbor-place",
      "poi_latitude": "33.72779",
      "poi_longitude": "-84.74438",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-690f615a7116.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-690f615a7116",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-690f615a7116.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJV9HpR7Mn9YgR6_nYNQu7wDQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_15ed0d727a0044da7638dad8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Cultural Arts Council Douglasville | Douglas County",
      "poi_type": "Entertainment",
      "poi_address": "8652 Campbellton St, Douglasville, GA 30134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-9a0f-742f-ab75-09601906ca20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-9a0f-742f-ab75-09601906ca20",
        "storage_key": "property/6767906449167768/01a0a57b-9a0f-742f-ab75-09601906ca20.webp",
        "width": 960,
        "height": 960
      },
      "poi_business_url": "http://www.artsdouglas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11553450477985514078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cultural-arts-council-douglasville--douglas-county",
      "poi_latitude": "33.7455258",
      "poi_longitude": "-84.7438547",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-949-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXau9kEQm9YgRXsJkNv8ZVqA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_gallery"
    },
    {
      "id": "ec_9f183a26f0b7ea4a282d6bd0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "GreyStone Amphitheater",
      "poi_type": "Entertainment",
      "poi_address": "6840 Church St, Douglasville, GA 30134, USA",
      "poi_short_description": "Amphitheater featuring live entertainment, plus a playground, a splash pad, and a boulder area.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-9c12-764b-ae3f-73e73eaa6ff0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-9c12-764b-ae3f-73e73eaa6ff0",
        "storage_key": "property/6767906449167768/01a0a57b-9c12-764b-ae3f-73e73eaa6ff0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.greystoneamp.com/Home",
      "poi_directions_map_url": "https://maps.google.com/?cid=13902290892389501848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greystone-amphitheater",
      "poi_latitude": "33.7479182",
      "poi_longitude": "-84.7528865",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 678-449-3280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-HEXT8m9YgRmEsGvejb7sA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amphitheatre"
    },
    {
      "id": "ec_2079f2e19f8bb40403e1e140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Deer Lick Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2105 Mack Rd, Douglasville, GA 30135, USA",
      "poi_short_description": "Field sports, disc & mini-golf, tennis, a playground, fishing lake, picnic areas & an amphitheater.",
      "poi_long_description": "Field sports, disc & mini-golf, tennis, a playground, fishing lake, picnic areas & an amphitheater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-d1e8-7169-86c1-f96ee3c0048c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-d1e8-7169-86c1-f96ee3c0048c",
        "storage_key": "property/6767906449167768/01a0a578-d1e8-7169-86c1-f96ee3c0048c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.celebratedouglascounty.com/Facilities/Facility/Details/Deer-Lick-Park-17",
      "poi_directions_map_url": "https://maps.google.com/?cid=12787023810962926613&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deer-lick-park",
      "poi_latitude": "33.7472957",
      "poi_longitude": "-84.6845365",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-920-7129",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e530-74ad-bbd5-c9dda275a06b",
        "storage_key": "property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJC5aqAzYh9YgRFSzoUmiidLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_669f7f5b3db09184e94f7585",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Boundary Waters Aquatic Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 GA-92, Douglasville, GA 30135, USA",
      "poi_short_description": "Recreation on 500 acres with sports fields, fitness room, horse & hiking trails & 2 swimming pools.",
      "poi_long_description": "Recreation on 500 acres with sports fields, fitness room, horse & hiking trails & 2 swimming pools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-9d9a-744f-bd6f-8dd427ab0320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-9d9a-744f-bd6f-8dd427ab0320",
        "storage_key": "property/6767906449167768/01a0a57b-9d9a-744f-bd6f-8dd427ab0320.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.douglascountyga.gov/Facilities/Facility/Details/Boundary-Waters-Park-13",
      "poi_directions_map_url": "https://maps.google.com/?cid=16243935850446183223&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boundary-waters-aquatic-center",
      "poi_latitude": "33.6669928",
      "poi_longitude": "-84.6648199",
      "poi_miles_from_property": "8.2 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-489-2175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE4s1zGTf9IgRN9sTiJcNbuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "ec_6830afa889d210cfe0c3d779",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Six Flags Over Georgia",
      "poi_type": "Entertainment",
      "poi_address": "275 Riverside Pkwy, Austell, GA 30168, USA",
      "poi_short_description": "Sprawling amusement park featuring high-speed roller coasters & water attractions, plus kids' rides.",
      "poi_long_description": "Sprawling amusement park featuring high-speed roller coasters & water attractions, plus kids' rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-9c3e-73c8-8583-5ba5706e3ec4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-9c3e-73c8-8583-5ba5706e3ec4",
        "storage_key": "property/6767906449167768/01a0a57b-9c3e-73c8-8583-5ba5706e3ec4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sixflags.com/overgeorgia?utm_source=googlebusinessprofile&utm_medium=organic&utm_campaign=Google+Business+Profile",
      "poi_directions_map_url": "https://maps.google.com/?cid=8357265512521447403&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "six-flags-over-georgia",
      "poi_latitude": "33.7683499",
      "poi_longitude": "-84.5500261",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-739-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1b5Y6CwZ9YgR67d2d7T4-nM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "ec_bcb88eb0e9d3f995c24d8119",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Wellstar Douglas Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "8954 Hospital Dr, Douglasville, GA 30134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-d005-741e-9811-e789a2039ab4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-d005-741e-9811-e789a2039ab4",
        "storage_key": "property/6767906449167768/01a0a578-d005-741e-9811-e789a2039ab4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.wellstar.org/locations/hospital/douglas-medical-center?utm_medium=listing&utm_source=google&utm_content=Wellstar_Douglas_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=6293250609189929855&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wellstar-douglas-medical-center",
      "poi_latitude": "33.7390326",
      "poi_longitude": "-84.7314746",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 470-644-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e506-75af-b7db-685fc11a4c83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e506-75af-b7db-685fc11a4c83",
        "storage_key": "property/6767906449167768/01a0a578-e506-75af-b7db-685fc11a4c83.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJsWWRGvgm9YgRf8NGAxYeVlc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_7ea6c116d6ad3adbb2ff2ca2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Peachtree Immediate Care - Lithia Springs",
      "poi_type": "Health and Wellness",
      "poi_address": "644 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-9f26-75ac-ae57-3414c1b07009.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-9f26-75ac-ae57-3414c1b07009",
        "storage_key": "property/6767906449167768/01a0a57b-9f26-75ac-ae57-3414c1b07009.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.peachtreemed.com/location/lithia-springs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9747630166417944816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peachtree-immediate-care---lithia-springs",
      "poi_latitude": "33.7884059",
      "poi_longitude": "-84.6192453",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-915-9887",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwvXyfYj9YgR8DA5v_2JRoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_4d5641446586bc87ab033028",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "630 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-9e7c-75cc-a857-c2e3555d499f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-9e7c-75cc-a857-c2e3555d499f",
        "storage_key": "property/6767906449167768/01a0a57b-9e7c-75cc-a857-c2e3555d499f.webp",
        "width": 796,
        "height": 503
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/011/00376?cid=loc_01100376P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=8373759770797131925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "33.7898077",
      "poi_longitude": "-84.620001",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-732-6995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c944-7705-8b2b-5d6727f9d50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c944-7705-8b2b-5d6727f9d50d",
        "storage_key": "property/6767906449167768/01a0a57b-c944-7705-8b2b-5d6727f9d50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqdCihBQi9YgRlcjRPCWSNXQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_9baa8f617a4b44f940c0a37b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Publix Pharmacy at Paradise Crossing",
      "poi_type": "Health and Wellness",
      "poi_address": "2675 Lee Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a11f-71a1-a654-9bf544c7b29d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a11f-71a1-a654-9bf544c7b29d",
        "storage_key": "property/6767906449167768/01a0a57b-a11f-71a1-a654-9bf544c7b29d.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.publix.com/pharmacy?utm_medium=maps&utm_source=google&utm_content=psmpharm_google_override",
      "poi_directions_map_url": "https://maps.google.com/?cid=705686824513421729&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-pharmacy-at-paradise-crossing",
      "poi_latitude": "33.7352433",
      "poi_longitude": "-84.6688112",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-920-3476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c944-7705-8b2b-5d6727f9d50d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c944-7705-8b2b-5d6727f9d50d",
        "storage_key": "property/6767906449167768/01a0a57b-c944-7705-8b2b-5d6727f9d50d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUU3N9Rgh9YgRocHLkW0aywk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_df9ea3c29bf4dfdf353affb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "6700 Douglas Blvd Ste E-1, Douglasville, GA 30135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-c755-749d-bf96-4c02c1ee3e1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-c755-749d-bf96-4c02c1ee3e1e",
        "storage_key": "property/6767906449167768/01a0a578-c755-749d-bf96-4c02c1ee3e1e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/douglasville-ga?utm_medium=yext&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16475414869560260711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "33.7277245",
      "poi_longitude": "-84.74608350000001",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 678-884-9291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJR2jYlvIn9YgRZ_hTi4hupOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "ec_3bd476e4a85c8b7625ef057c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Onelife Fitness Douglasville",
      "poi_type": "Health and Wellness",
      "poi_address": "9365 The Landing Dr, Douglasville, GA 30135, USA",
      "poi_short_description": "Large chain offering cardiovascular machines, classes, a pool and saunas for exercise.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-c52c-72e1-a304-2124579c1a86.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a578-c52c-72e1-a304-2124579c1a86",
        "storage_key": "property/6767906449167768/01a0a578-c52c-72e1-a304-2124579c1a86.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.onelifefitness.com/gyms/douglasville",
      "poi_directions_map_url": "https://maps.google.com/?cid=6863370107242590997&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "onelife-fitness-douglasville",
      "poi_latitude": "33.7288833",
      "poi_longitude": "-84.74042419999999",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-949-1116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRSi1Nsn9YgRFbM6tL-WP18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_a5e7117f04fbf0f288660cd6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Keep It Moving Yoga and Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "6643 Church St, Douglasville, GA 30134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a499-734b-9885-c1049b6200fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a499-734b-9885-c1049b6200fe",
        "storage_key": "property/6767906449167768/01a0a57b-a499-734b-9885-c1049b6200fe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.kimyb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18293167548092318908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "keep-it-moving-yoga-and-barre",
      "poi_latitude": "33.7509153",
      "poi_longitude": "-84.7477304",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-842-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJfzHoqkEm9YgRvAS_sPZi3v0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_6cb618bee66a81bbf52ed861",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Just Breathe Yoga Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3216 GA-5, Douglasville, GA 30135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a3f3-7435-a0dd-aacb3185c298.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a3f3-7435-a0dd-aacb3185c298",
        "storage_key": "property/6767906449167768/01a0a57b-a3f3-7435-a0dd-aacb3185c298.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://douglasvilleyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4354584796396196881&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "just-breathe-yoga-center",
      "poi_latitude": "33.7174287",
      "poi_longitude": "-84.7639749",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 678-653-9573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_TV0IVwn9YgRERSD_cyXbjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_5650e719d597f894b76cd002",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Douglasville Wellness & Chiropractic Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3677 Bill Arp Road, GA-5, Douglasville, GA 30135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a2b1-7799-986b-84ef299c2f9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a2b1-7799-986b-84ef299c2f9d",
        "storage_key": "property/6767906449167768/01a0a57b-a2b1-7799-986b-84ef299c2f9d.webp",
        "width": 480,
        "height": 640
      },
      "poi_business_url": "http://www.douglasvillewellness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4145742137977908733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "douglasville-wellness--chiropractic-center",
      "poi_latitude": "33.7061169",
      "poi_longitude": "-84.77451959999999",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-942-9494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlZOYHNIn9YgR_a2KaIKiiDk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chiropractor"
    },
    {
      "id": "ec_ba15963cc27f0d2681cbc9cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Woodrow Wilson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6635 Mt Vernon Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Calm area with a playground, dog park and a track for cycling and jogging.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a94d-73ac-adbb-d6965c5ff604.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a94d-73ac-adbb-d6965c5ff604",
        "storage_key": "property/6767906449167768/01a0a57b-a94d-73ac-adbb-d6965c5ff604.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.douglascountyga.gov/Facilities/Facility/Details/Woodrow-Wilson-Park-24",
      "poi_directions_map_url": "https://maps.google.com/?cid=7095446210452794771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodrow-wilson-park",
      "poi_latitude": "33.7897866",
      "poi_longitude": "-84.6381411",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-489-3918",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e530-74ad-bbd5-c9dda275a06b",
        "storage_key": "property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxVVNEgi9YgRky3uMLwWeGI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_b72f94812863240af5c68ead",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Dog River Trails",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Unnamed Road, Douglasville, GA 30135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a8f2-779d-a7c3-0ffe6dea48cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a8f2-779d-a7c3-0ffe6dea48cd",
        "storage_key": "property/6767906449167768/01a0a57b-a8f2-779d-a7c3-0ffe6dea48cd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.douglascountyga.gov/Facilities/Facility/Details/Dog-River-Park-Trails-19",
      "poi_directions_map_url": "https://maps.google.com/?cid=4903580945377198781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dog-river-trails",
      "poi_latitude": "33.6377541",
      "poi_longitude": "-84.8273509",
      "poi_miles_from_property": "16.8 mi",
      "poi_walking_minutes": "6 hours 12 mins",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c967-74ff-9615-bd4b6ab51703.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c967-74ff-9615-bd4b6ab51703",
        "storage_key": "property/6767906449167768/01a0a57b-c967-74ff-9615-bd4b6ab51703.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJs7UKMebX9IgRvQKVuOMEDUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "ec_7cc217b4633691e33c84b683",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Dog River Reservoir",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "River Rd, Douglasville, GA 30135, USA",
      "poi_short_description": "Lake with fishing and a public restroom, plus picnic tables.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-ad3c-729b-9e57-d44d12debe76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-ad3c-729b-9e57-d44d12debe76",
        "storage_key": "property/6767906449167768/01a0a57b-ad3c-729b-9e57-d44d12debe76.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ddcwsa.com/customer-services/consumer-information/recreational-complex/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13263028884775141493&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dog-river-reservoir",
      "poi_latitude": "33.625615",
      "poi_longitude": "-84.7966077",
      "poi_miles_from_property": "17.7 mi",
      "poi_walking_minutes": "6 hours 28 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "+1 770-920-3871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e530-74ad-bbd5-c9dda275a06b",
        "storage_key": "property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3aYPgRTX9IgRdYDECoC-D7g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_661e0ab278aaa965c9d69d61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Bill Arp Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4801 GA-5, Douglasville, GA 30135, USA",
      "poi_short_description": "Park with facilities for baseball, football, and basketball.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a83d-7739-b5b8-a5797752f80a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a83d-7739-b5b8-a5797752f80a",
        "storage_key": "property/6767906449167768/01a0a57b-a83d-7739-b5b8-a5797752f80a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.douglascountyga.gov/Facilities/Facility/Details/Bill-Arp-Park-14",
      "poi_directions_map_url": "https://maps.google.com/?cid=10513959771639535953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-arp-park",
      "poi_latitude": "33.67414",
      "poi_longitude": "-84.807603",
      "poi_miles_from_property": "13.6 mi",
      "poi_walking_minutes": "5 hours 4 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 678-449-3974",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e530-74ad-bbd5-c9dda275a06b",
        "storage_key": "property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ0dnUc7X9IgRUVlS-7QW6ZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_6c0e5eb042fae97eb115a5b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Fairplay Ball Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8600-8646 Duncan Memorial Hwy, Douglasville, GA 30135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a941-728d-b5d5-f2ccb1c30d3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a941-728d-b5d5-f2ccb1c30d3c",
        "storage_key": "property/6767906449167768/01a0a57b-a941-728d-b5d5-f2ccb1c30d3c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6245955271771479918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairplay-ball-park",
      "poi_latitude": "33.6167949",
      "poi_longitude": "-84.8497057",
      "poi_miles_from_property": "19.5 mi",
      "poi_walking_minutes": "7 hours 12 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e530-74ad-bbd5-c9dda275a06b",
        "storage_key": "property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEap4tKPW9IgRbt_qKDoXrlY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_f1d83219d8978c9a25f52107",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Violet F. Stout Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5420 Stout Pkwy SW, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Picturesque park for kids, dogs, and horses, featuring hiking trails, a creek and picnic facilities.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-ace8-77fb-ae28-711a2607db80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-ace8-77fb-ae28-711a2607db80",
        "storage_key": "property/6767906449167768/01a0a57b-ace8-77fb-ae28-711a2607db80.webp",
        "width": 1280,
        "height": 928
      },
      "poi_business_url": "https://www.cobbcounty.org/parks/parks-and-nature/locations/stout-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6744664054410621049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "violet-f-stout-memorial-park",
      "poi_latitude": "33.8170772",
      "poi_longitude": "-84.71312259999999",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 770-745-6674",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e530-74ad-bbd5-c9dda275a06b",
        "storage_key": "property/6767906449167768/01a0a578-e530-74ad-bbd5-c9dda275a06b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSYbXmEk9YgRebB9BDncmV0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_176658105b6150a23b208ba1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Connect Douglas Multi-Modal Transportation Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8800 Dorris Rd, Douglasville, GA 30134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-adae-707e-b684-ca775c74a48e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-adae-707e-b684-ca775c74a48e",
        "storage_key": "property/6767906449167768/01a0a57b-adae-707e-b684-ca775c74a48e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.connectdouglas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7810159356507520013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "connect-douglas-multi-modal-transportation-center",
      "poi_latitude": "33.7425637",
      "poi_longitude": "-84.7254569",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-949-7665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e9e3-706b-b988-02f3baabb6bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e9e3-706b-b988-02f3baabb6bd",
        "storage_key": "property/6767906449167768/01a0a578-e9e3-706b-b988-02f3baabb6bd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbGyPPcm9YgRDfzSA45CY2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_5d48abceb791cedbcbc07ca8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Floyd Road Park & Ride Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "4342 Floyd Rd SW, Mableton, GA 30126, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-b07f-71e9-95ce-21932b203371.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-b07f-71e9-95ce-21932b203371",
        "storage_key": "property/6767906449167768/01a0a57b-b07f-71e9-95ce-21932b203371.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://floyd-lot.keeq.io/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15347859697643022292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "floyd-road-park--ride-lot",
      "poi_latitude": "33.84684379999999",
      "poi_longitude": "-84.5856335",
      "poi_miles_from_property": "9.6 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 770-427-4444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c967-74ff-9615-b89c46d8ddd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c967-74ff-9615-b89c46d8ddd3",
        "storage_key": "property/6767906449167768/01a0a57b-c967-74ff-9615-b89c46d8ddd3.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6w-RxgY9YgR1OeLHBSN_tQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_9e7e1743197817c3d2308f62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Mableton Park & Ride Lot",
      "poi_type": "Transportation & Transit",
      "poi_address": "Maran Ln SW, Mableton, GA 30126, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7990666166941892370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mableton-park--ride-lot",
      "poi_latitude": "33.8257897",
      "poi_longitude": "-84.5744606",
      "poi_miles_from_property": "8.4 mi",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c967-74ff-9615-b89c46d8ddd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c967-74ff-9615-b89c46d8ddd3",
        "storage_key": "property/6767906449167768/01a0a57b-c967-74ff-9615-b89c46d8ddd3.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVfE8Y9YgREr9N34qM5G4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_08cb7d8bb6cf88a6ca077d7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "I-20 Lithia Springs, GA Scales",
      "poi_type": "Transportation & Transit",
      "poi_address": "I-20, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15164346688339370908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "i-20-lithia-springs-ga-scales",
      "poi_latitude": "33.7726964",
      "poi_longitude": "-84.6302826",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhxtTHAAj9YgRnONWCfiUctI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_cf90936d518cc75c4d96a834",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "RaceTrac",
      "poi_type": "Transportation & Transit",
      "poi_address": "1211 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-b120-742e-bbbd-e0f2629046a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-b120-742e-bbbd-e0f2629046a6",
        "storage_key": "property/6767906449167768/01a0a57b-b120-742e-bbbd-e0f2629046a6.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.racetrac.com/locations/georgia/lithia-springs/blairs-bridge?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=14300682780092952424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "racetrac",
      "poi_latitude": "33.7708436",
      "poi_longitude": "-84.6032709",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-829-6474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e526-711f-a172-773c1fe4b1e8",
        "storage_key": "property/6767906449167768/01a0a578-e526-711f-a172-773c1fe4b1e8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuaifdKsY9YgRaG_8YDg7dsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "ec_33c3535ac8e1cc20938e188e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "JP Marathon - Lee Road 333",
      "poi_type": "Shopping & Retail",
      "poi_address": "7512 Lee Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "Clean fuel station with friendly service plus a Burger King fast food restaurant.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-b466-74df-ac91-c25b1b36001d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-b466-74df-ac91-c25b1b36001d",
        "storage_key": "property/6767906449167768/01a0a57b-b466-74df-ac91-c25b1b36001d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.jonespetroleum.com/locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=12439430483354017633&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jp-marathon---lee-road-333",
      "poi_latitude": "33.7712254",
      "poi_longitude": "-84.6525423",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 770-941-3460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c944-7705-8b2b-58abf17a249a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c944-7705-8b2b-58abf17a249a",
        "storage_key": "property/6767906449167768/01a0a57b-c944-7705-8b2b-58abf17a249a.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ_3be4tUj9YgRYV97IB68oaw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_202ae0ab824d8497e7cc43e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "bp",
      "poi_type": "Transportation & Transit",
      "poi_address": "983 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-b7b8-7330-996c-2dfdf2ea3640.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-b7b8-7330-996c-2dfdf2ea3640",
        "storage_key": "property/6767906449167768/01a0a57b-b7b8-7330-996c-2dfdf2ea3640.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://map.bp.com/en-US/US/gas-station/lithia-springs/bp/49109445979833012200100000000000",
      "poi_directions_map_url": "https://maps.google.com/?cid=445911111390557191&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bp",
      "poi_latitude": "33.7795004",
      "poi_longitude": "-84.6076681",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-944-0394",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c979-71a9-8fbd-779c6ec8e5c6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c979-71a9-8fbd-779c6ec8e5c6",
        "storage_key": "property/6767906449167768/01a0a57b-c979-71a9-8fbd-779c6ec8e5c6.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJRzCydwgi9YgRB3TVE8sxMAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_890e87eaa48dfd959e14b887",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "West Douglas Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "7500 Douglas Blvd, Douglasville, GA 30135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-b6ab-764e-ba2e-747ca641a604.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-b6ab-764e-ba2e-747ca641a604",
        "storage_key": "property/6767906449167768/01a0a57b-b6ab-764e-ba2e-747ca641a604.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.xpressga.com/route-463_/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5205425367298545354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-douglas-park--ride",
      "poi_latitude": "33.7232019",
      "poi_longitude": "-84.7735548",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 407-786-9739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c967-74ff-9615-b89c46d8ddd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c967-74ff-9615-b89c46d8ddd3",
        "storage_key": "property/6767906449167768/01a0a57b-c967-74ff-9615-b89c46d8ddd3.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxrEnHgo9YgRyhajwspiPUg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_5128dfeaca24e3213c5b5d63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-b6f2-73c6-af8e-bc58d532052e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-b6f2-73c6-af8e-bc58d532052e",
        "storage_key": "property/6767906449167768/01a0a57b-b6f2-73c6-af8e-bc58d532052e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "23.1 mi",
      "poi_walking_minutes": "8 hours 32 mins",
      "poi_biking_minutes": "2 hours 10 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c967-74ff-9615-b47f3d54a427.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c967-74ff-9615-b47f3d54a427",
        "storage_key": "property/6767906449167768/01a0a57b-c967-74ff-9615-b47f3d54a427.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_568a28a3f21cf07e227f6b58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "ATL8 Amazon Fulfillment Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2201 Thornton Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-b9ac-70b8-86a7-18a38f48b8fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-b9ac-70b8-86a7-18a38f48b8fd",
        "storage_key": "property/6767906449167768/01a0a57b-b9ac-70b8-86a7-18a38f48b8fd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7945568470259108440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atl8-amazon-fulfillment-center",
      "poi_latitude": "33.7444627",
      "poi_longitude": "-84.592467",
      "poi_miles_from_property": "6.4 mi",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-863-7714",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1pTzmkf9YgRWIpWIG1URG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "ec_29323b62911fe7de67cf2b55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Medline Industries Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9103 Riverside Pkwy, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-bc1b-7546-b603-f4f9a13c127e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-bc1b-7546-b603-f4f9a13c127e",
        "storage_key": "property/6767906449167768/01a0a57b-bc1b-7546-b603-f4f9a13c127e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.medline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4782931392370125973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medline-industries-inc",
      "poi_latitude": "33.7346678",
      "poi_longitude": "-84.5933955",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-948-1293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH3F33mQf9YgRlSxJo8JiYEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_4077a7c4db6abd42bc21203d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Stitch Fix",
      "poi_type": "Major Employers & Offices",
      "poi_address": "801 Factory Shoals Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-bc0e-71c3-b5d7-c347e2cce0ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-bc0e-71c3-b5d7-c347e2cce0ca",
        "storage_key": "property/6767906449167768/01a0a57b-bc0e-71c3-b5d7-c347e2cce0ca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.stitchfix.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8056566884085121628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stitch-fix",
      "poi_latitude": "33.7596994",
      "poi_longitude": "-84.59574889999999",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 415-882-7765",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd308w-Ef9YgRXMIRQ-Wszm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "ec_64ff22cd1e6a482039e553fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Gordon Food Service Douglasville Distribution Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1500 N River Rd, Lithia Springs, GA 30122, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-bb5c-747c-88e2-a09c6aec3a83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-bb5c-747c-88e2-a09c6aec3a83",
        "storage_key": "property/6767906449167768/01a0a57b-bb5c-747c-88e2-a09c6aec3a83.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.gfs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4117286230236175554&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gordon-food-service-douglasville-distribution-center",
      "poi_latitude": "33.7267936",
      "poi_longitude": "-84.61076849999999",
      "poi_miles_from_property": "9.1 mi",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 888-437-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrwq8gywg9YgRwpzVFwOKIzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wholesaler"
    },
    {
      "id": "ec_1960a40cf6cba62334952fd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "McMaster-Carr",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1901 Riverside Pkwy, Douglasville, GA 30135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-bdf5-735a-8a44-c095cef0fac1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-bdf5-735a-8a44-c095cef0fac1",
        "storage_key": "property/6767906449167768/01a0a57b-bdf5-735a-8a44-c095cef0fac1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mcmaster.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6756671013647681204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcmaster-carr",
      "poi_latitude": "33.7185136",
      "poi_longitude": "-84.62377389999999",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-346-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e51b-772e-ab23-f4137135050c",
        "storage_key": "property/6767906449167768/01a0a578-e51b-772e-ab23-f4137135050c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL09Jdpgf9YgRtAamEH2ExF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "ec_c4d588daabda02a16c95df98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Douglas County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8700 Hospital Dr 1st floor, Douglasville, GA 30134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-bf32-7030-b6a1-8d4f6ad83a0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-bf32-7030-b6a1-8d4f6ad83a0a",
        "storage_key": "property/6767906449167768/01a0a57b-bf32-7030-b6a1-8d4f6ad83a0a.webp",
        "width": 1280,
        "height": 871
      },
      "poi_business_url": "https://www.douglascountyga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12916217555866634893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "douglas-county-courthouse",
      "poi_latitude": "33.7435574",
      "poi_longitude": "-84.7308032",
      "poi_miles_from_property": "6.5 mi",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-949-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a578-e9e3-706b-b988-02f3baabb6bd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a578-e9e3-706b-b988-02f3baabb6bd",
        "storage_key": "property/6767906449167768/01a0a578-e9e3-706b-b988-02f3baabb6bd.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCf0vrUIm9YgRjUoYG2-fP7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "ec_e0545ad621d02aea4204b685",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Douglas County School System",
      "poi_type": "Education",
      "poi_address": "11490 Veterans Memorial Hwy, Douglasville, GA 30134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-bfaf-738a-952a-09bfc8b64a5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-bfaf-738a-952a-09bfc8b64a5f",
        "storage_key": "property/6767906449167768/01a0a57b-bfaf-738a-952a-09bfc8b64a5f.webp",
        "width": 1280,
        "height": 833
      },
      "poi_business_url": "https://www.dcssga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7224824640906735772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "douglas-county-school-system",
      "poi_latitude": "33.7797268",
      "poi_longitude": "-84.70457750000001",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-651-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH9hZRykm9YgRnDC8bbu7Q2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_1e64cee4d6d06e8bad412d54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "West Georgia Technical College",
      "poi_type": "Education",
      "poi_address": "4600 Timber Ridge Dr, Douglasville, GA 30135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c1bf-72d4-9093-eefda9ca8566.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c1bf-72d4-9093-eefda9ca8566",
        "storage_key": "property/6767906449167768/01a0a57b-c1bf-72d4-9093-eefda9ca8566.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "http://www.westgatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6244010422073574355&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-georgia-technical-college",
      "poi_latitude": "33.7345293",
      "poi_longitude": "-84.7290222",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 706-845-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJga6Infkm9YgR00OIjWUup1Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_c573c8f500ac90d64f738957",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "poi_name": "Georgia Highlands College",
      "poi_type": "Education",
      "poi_address": "4841 Bill Arp Rd, Douglasville, GA 30135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c23c-7405-95c6-e148adf79d33.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c23c-7405-95c6-e148adf79d33",
        "storage_key": "property/6767906449167768/01a0a57b-c23c-7405-95c6-e148adf79d33.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.highlands.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10702019686703614121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-highlands-college",
      "poi_latitude": "33.6737823",
      "poi_longitude": "-84.806221",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 678-872-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0a57b-c943-74de-970c-64e9ee6de52b",
        "storage_key": "property/6767906449167768/01a0a57b-c943-74de-970c-64e9ee6de52b.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr-T2VNgn9YgRqcg0DTQ2hZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "ec_6ff65a86d48722bff91b7022",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fcc4e16552f22804550900d5",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_983533a35b20f127a739338e",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2d0cbea934eac9255bbc39ed",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_fbdff1c9e0d7c0c6a6625f82",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_67be21778523196cdffd8918",
      "source": "entrata",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_fa74eb1638e7e55ab5f1ef03",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "rating": "5",
      "name": "Trystin Berry",
      "text": "I recently went on a tour here and I was thoroughly impressed. The property is beautiful, quiet, modern, and well maintained. Keisha’s customer service was professional and she is always happy to pick up when you call to ask questions.",
      "date": "2026-05-19",
      "title": "false"
    },
    {
      "id": "ec_3354d92364ff523dfd4ffb9e",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "rating": "5",
      "name": "Keir Seabrooks",
      "text": "My experience with Michelle was absolutely amazing! Thank you so much for assisting me in finding a place to call home. I rarely leave reviews, but now that I’m settled, I can’t stop thinking about how wonderful it was to meet her.\n\nMichelle, you are truly incredible! Keep that spark ; it shines through in everything you do. I’ve visited many properties, and I have never experienced hospitality like this before.\nThank you for making this such a positive and memorable experience!",
      "date": "2026-01-17",
      "title": "false"
    },
    {
      "id": "ec_1efb2e87435a31230d417d47",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "rating": "4",
      "name": "Dorlene Amponsah",
      "text": "I am not someone who typically leaves reviews, but after living here for a year, I felt it was a good opportunity to share my honest experience. Overall, this is a very nice apartment community. My husband and I truly enjoy the amenities that are offered. The community itself is pretty easy going.\n\nThat being said, we felt that certain aspects of the resident experience were smoother under the previous management team. We rarely had any concerns, but when issues did arise, maintenance was exceptional, communication was prompt, and management was highly responsive. Even the maintenance team we had was exceptional!\n\nSince the transition to the new management team earlier this year, it has taken some adjustment. While the office staff are professional, direct, and straightforward, which I appreciate, I believe there is room for improvement when it comes to communication. On some occasions, I have sent emails regarding important matters and have not received a timely response. In many cases, I have had to send follow-up emails, even just recently, I sent an email last week and this week with no response yet. Me and my husband don't always have the flexibility to stop by the office due to work.\n\nAlthough these concerns have not overshadowed our overall positive experience, consistent and responsive communication is important to residents. I believe improving this area would greatly enhance the experience for current and future tenants.\n\nOverall, this is still a great place to live, and I hope to see continued improvements as the new management team strengthens themselves in their roles over time.",
      "date": "2026-06-12",
      "title": "false"
    },
    {
      "id": "ec_5342958b88d7d5c79163e68a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "rating": "5",
      "name": "Stephane Foreste",
      "text": "Fantastic location easy to commute to ATL  best amenities at the novo sweetwater and the mng always arrange  various type of food vendor from carribean to Spanish and authentic southern american food food vendor's to bring their test to the novo sweetwater community i strongly recommend you to call then",
      "date": "2026-05-14",
      "title": "false"
    },
    {
      "id": "ec_a1a57248b8fe6dacc00e11e9",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "rating": "5",
      "name": "Miles Richardson",
      "text": "I want to leave a review , putting a spotlight on Tiara. Her customer service was top tier and she went above and beyond to make sure me and my cousin had the smoothest move in transition. If you coming to Novo I would definitely ask for her, very professional and got the job done.",
      "date": "2026-08-25",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_3a0213d3bd6760311e4da08b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a497-714c-8c81-963dcb01a437.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a497-714c-8c81-963dcb01a437",
        "storage_key": "property/6767906449167768/01a0a57b-a497-714c-8c81-963dcb01a437.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 756SF - Model",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=AV5CW3yQHmE"
    },
    {
      "id": "ec_053fb5230674c61421d7f58f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a603-72c8-b2b3-36e4f4889b86.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a603-72c8-b2b3-36e4f4889b86",
        "storage_key": "property/6767906449167768/01a0a57b-a603-72c8-b2b3-36e4f4889b86.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1,248SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=NFLYP2m8TKR"
    },
    {
      "id": "ec_cdded7329427c6e697374fdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-bc6b-740e-9dc8-32e8a77b8575.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57b-bc6b-740e-9dc8-32e8a77b8575",
        "storage_key": "property/6767906449167768/01a0a57b-bc6b-740e-9dc8-32e8a77b8575.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1,176SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yKXcZnpmQB4"
    },
    {
      "id": "ec_593372d802abb6d44e135747",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-a410-75c4-ac0a-a679689e9636.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57b-a410-75c4-ac0a-a679689e9636",
        "storage_key": "property/6767906449167768/01a0a57b-a410-75c4-ac0a-a679689e9636.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "1BR, 1BA - 756SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=bjsefzVDTJr"
    },
    {
      "id": "ec_2539611884aa49371a6a30a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-bca2-72ec-ad7d-eef3b2bb8ec5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57b-bca2-72ec-ad7d-eef3b2bb8ec5",
        "storage_key": "property/6767906449167768/01a0a57b-bca2-72ec-ad7d-eef3b2bb8ec5.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Cyber Cafe",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zcFP7C4wiip"
    },
    {
      "id": "ec_0be8c90dc94337165e339bf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167768/01a0a57b-e04c-7059-9db8-ff2522afd393.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0a57b-e04c-7059-9db8-ff2522afd393",
        "storage_key": "property/6767906449167768/01a0a57b-e04c-7059-9db8-ff2522afd393.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=PHmD2wXS5t7"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0cfa5-8f9f-7141-8aad-9bb213b0f421",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "The Leila Sweetwater Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "resort-inspired-swimming-pool-lithia-springs",
      "search_query": "resort-inspired swimming pool Lithia Springs",
      "category": "Amenity",
      "h1_title": "Resort-Inspired Pool in Lithia Springs",
      "h2_subtitle": "Experience a resort-inspired swimming pool right here in Lithia Springs. Dive into relaxation at The Leila Sweetwater's spectacular pool setting.",
      "page_copy": "Nestled in the heart of Lithia Springs, The Leila Sweetwater offers a resort-inspired swimming pool that promises both relaxation and luxury. Our sun deck accentuates the pool's vibrant atmosphere, providing a perfect spot for basking in the Georgia sun or relaxing with a good book. Residents enjoy exclusive access to this tranquil oasis, enhanced by the surrounding beauty of our well-kept community grounds.\n\nIn addition to the enticing pool area, The Leila Sweetwater features a range of top-tier amenities. Enjoy the private feel of controlled access and the elegance of granite counters in our modern clubhouse. Combine these with our stunning garden tubs, and you’ll find a harmonious blend of style and comfort designed to elevate your living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Inspired Pool in Lithia Springs",
      "seo_description": "Discover Lithia Springs' resort-inspired swimming pool at The Leila Sweetwater, offering relaxation and luxury in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "state-of-the-art-fitness-center-douglas-county",
      "search_query": "state-of-the-art fitness center Douglas County",
      "category": "Amenity",
      "h1_title": "Fitness Center in Douglas County",
      "h2_subtitle": "Discover a state-of-the-art fitness center right in Douglas County. Achieve your fitness goals at The Leila Sweetwater.",
      "page_copy": "At The Leila Sweetwater in Douglas County, residents are invited to elevate their fitness routine with our state-of-the-art fitness center. Our facility is equipped with modern exercise machines and ample space for a comprehensive workout experience, ensuring you have everything you need to stay fit right at home.\n\nIn addition to our premier fitness amenities, The Leila Sweetwater offers a host of exclusive features. Residents relish in the privacy of a gated community, enjoy the chic design of granite countertops, relax in opulent garden tubs, and unwind by our resort-style swimming pool. These features make The Leila Sweetwater a perfect place for a balanced lifestyle of health, comfort, and leisure.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center in Douglas County",
      "seo_description": "Train in style at The Leila Sweetwater's state-of-the-art fitness center, located in Douglas County. Achieve your fitness ambitions today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "apartments-with-garages-ga-30122",
      "search_query": "apartments with garages in GA 30122",
      "category": "Amenity",
      "h1_title": "Apartments with Garages in 30122",
      "h2_subtitle": "Looking for apartments with garages in GA 30122? Discover the perks of living at The Leila Sweetwater in Lithia Springs.",
      "page_copy": "The Leila Sweetwater in Lithia Springs, GA 30122, is more than just a residence—it's a community designed to meet your needs, including the convenience of apartments with available garages. Safeguard your vehicle while enjoying easy access whenever you need it, adding an extra layer of comfort to your everyday living.\n\nBeyond the practical benefits of garages, our community offers a blend of luxurious features such as granite counters and spacious garden tubs. Socialize in our modern clubhouse or take in the day by relaxing at our resort-inspired swimming pool with an inviting sun deck. Enjoy peace of mind within our gated environment, making The Leila Sweetwater the perfect choice for your next home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Garages in 30122",
      "seo_description": "Explore The Leila Sweetwater’s apartments with garages in GA 30122. Ideal living blend with convenience and luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "apartments-with-granite-counters-lithia-springs",
      "search_query": "apartments with granite counters in Lithia Springs",
      "category": "Amenity",
      "h1_title": "Apartments with Granite Counters",
      "h2_subtitle": "Searching for apartments with granite counters in Lithia Springs? Experience luxury and elegance at The Leila Sweetwater.",
      "page_copy": "The Leila Sweetwater proudly offers apartments with granite counters, providing residents in Lithia Springs with a touch of elegance and sophistication. These high-end finishes not only enhance the aesthetic of your home but also offer durability and style, making meal preparation a delight.\n\nExperience the charm of a community that complements luxury features with a range of superior amenities. Our residents enjoy a gated environment, soothing garden tubs, and a welcoming clubhouse. Not to forget, the alluring resort-inspired swimming pool is perfect for relaxation. At The Leila Sweetwater, you'll find a perfect blend of comfort and sophistication right in the heart of Lithia Springs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Granite Counters",
      "seo_description": "Discover granite-counter-enhanced living at The Leila Sweetwater. Elegant apartment features await in Lithia Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-douglas-county",
      "search_query": "in-unit laundry apartments Douglas County",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Douglas County",
      "h2_subtitle": "Explore in-unit laundry apartments in Douglas County. Enjoy the convenience of home laundry at The Leila Sweetwater.",
      "page_copy": "Experience the ultimate convenience with in-unit laundry facilities at The Leila Sweetwater in Douglas County. Forget about the hassle of shared laundry rooms or trips to the laundromat. Our in-unit washers and dryers ensure you can handle laundry at your convenience, giving you more time to enjoy life’s pleasures.\n\nOur community is thoughtfully designed with residents in mind. Boasting amenities like controlled access, stylish granite counters, and opulent garden tubs, The Leila Sweetwater combines practical living with luxury. Relax by our resort-inspired swimming pool or gather with friends in the clubhouse. Discover the perfect blend of convenience and style in Douglas County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Douglas County",
      "seo_description": "Enjoy in-unit laundry convenience at The Leila Sweetwater. Premium living in Douglas County with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-lithia-springs-ga",
      "search_query": "one bedroom apartments Lithia Springs GA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Lithia Springs",
      "h2_subtitle": "Discover stylish one bedroom apartments in Lithia Springs, GA. Enjoy the perfect blend of comfort and convenience at The Leila Sweetwater.",
      "page_copy": "The Leila Sweetwater presents exceptional one bedroom apartments in Lithia Springs, GA, designed to cater to your lifestyle needs. Each apartment provides a spacious layout, allowing you to personalize your living space and create a home that reflects your unique style.\n\nOur community ensures both comfort and convenience, offering features like upscale granite counters and indulgent garden tubs. Relax and socialize in our exclusive clubhouse, or take a refreshing dip in our resort-inspired swimming pool with a sun deck. With controlled access, The Leila Sweetwater guarantees a serene and secure living environment in the heart of Lithia Springs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Lithia Springs",
      "seo_description": "Explore The Leila Sweetwater’s one bedroom apartments in Lithia Springs, GA. Enjoy luxury living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-douglas-county",
      "search_query": "two bedroom apartments Douglas County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Douglas County",
      "h2_subtitle": "Find spacious two bedroom apartments in Douglas County. Embrace modern living at The Leila Sweetwater.",
      "page_copy": "Step into a world of comfort with our two bedroom apartments in Douglas County, offered at The Leila Sweetwater. These units provide ample space, perfect for a variety of living arrangements, whether sharing with family, a friend, or simply desiring a home office.\n\nYou'll enjoy premium finishes like granite countertops and relaxing garden tubs, set within a beautifully gated community. Residents can unwind at our resort-inspired swimming pool, complete with a sun deck, or socialize in our fully-equipped clubhouse. Embrace the ideal fusion of practicality and luxury in our well-designed community in Douglas County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Douglas County",
      "seo_description": "Discover spacious two bedroom apartments at The Leila Sweetwater. Enjoy luxury living in Douglas County with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-30122",
      "search_query": "3 bedroom apartments near 30122",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 30122",
      "h2_subtitle": "Explore 3 bedroom apartments near the 30122 area. Experience spacious living at The Leila Sweetwater.",
      "page_copy": "Discover the ideal living space with our expansive 3 bedroom apartments near the 30122 area at The Leila Sweetwater. Perfectly designed for families or those needing extra room, these apartments offer modern amenities and stylish finishes that complete a luxurious lifestyle.\n\nEach unit features high-quality granite counters and relaxing garden tubs. Enjoy the elegance and secure comfort of a gated community, alongside resort-style amenities like our swimming pool with a sun deck and a welcoming clubhouse. These spacious homes provide the perfect blend of functionality and aesthetics, making them a top choice in the 30122 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 30122",
      "seo_description": "Find spacious 3 bedroom apartments at The Leila Sweetwater near 30122. Enjoy luxury living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "apartments-near-wellstar-douglas-medical-center-ga",
      "search_query": "apartments near Wellstar Douglas Medical Center GA",
      "category": "Hospital",
      "h1_title": "Apartments Near Wellstar Douglas Medical Center",
      "h2_subtitle": "Discover apartments near Wellstar Douglas Medical Center, GA. Enjoy convenient living at The Leila Sweetwater.",
      "page_copy": "The Leila Sweetwater offers prime location apartments near Wellstar Douglas Medical Center in GA, where convenience meets comfort. Perfectly situated, our community provides easy access to this pivotal medical facility while offering a serene living environment.\n\nThese luxury apartments feature sophisticated touches like granite countertops and garden tubs, set within a gated community that promotes tranquility and security. Residents can take advantage of our resort-inspired swimming pool with a sun deck or engage with neighbors in our stylish clubhouse. Enjoy effortless living infused with modern amenities, all while being near Wellstar Douglas Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Wellstar Douglas Medical Center",
      "seo_description": "Find convenient living near Wellstar Douglas Medical Center, GA at The Leila Sweetwater. Enjoy luxury and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "apartments-near-sweetwater-creek-state-park-lithia-springs",
      "search_query": "apartments near Sweetwater Creek State Park Lithia Springs",
      "category": "Park",
      "h1_title": "Apartments Near Sweetwater Creek State Park",
      "h2_subtitle": "Live near Sweetwater Creek State Park in Lithia Springs. Explore nature and modern living at The Leila Sweetwater.",
      "page_copy": "Nestled in the vibrant locale of Lithia Springs, The Leila Sweetwater offers exquisite apartments near Sweetwater Creek State Park. Embrace the beauty of nature with the park's trails and scenic views just a stone's throw away from your doorstep.\n\nOur community boasts features that complement this serene setting, including architecturally refined granite counters and soothing garden tubs. Enjoy the perks of a resort-style swimming pool and a sun deck for ultimate relaxation. With controlled access, a gated environment, and a lively clubhouse, the combination of nature and luxury living makes our community a prime choice for those who love the outdoors yet crave modern conveniences.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sweetwater Creek State Park",
      "seo_description": "Experience nature and luxury living near Sweetwater Creek State Park at The Leila Sweetwater in Lithia Springs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "the-leila-sweetwater-close-to-deer-lick-park",
      "search_query": "The Leila Sweetwater close to Deer Lick Park Douglas County",
      "category": "Park",
      "h1_title": "The Leila Sweetwater Close to Deer Lick Park",
      "h2_subtitle": "Enjoy living at The Leila Sweetwater near Deer Lick Park, Douglas County. A perfect blend of convenience and comfort awaits you.",
      "page_copy": "The Leila Sweetwater, located conveniently close to Deer Lick Park in Douglas County, presents an exceptional living experience. Our community is ideally positioned for those who love outdoor activities, with the park offering a variety of recreational options just minutes away.\n\nResidents of The Leila Sweetwater are treated to stylish surroundings, featuring luxury amenities like granite countertops and garden tubs within each apartment. The community's resort-inspired swimming pool with a sun deck, a welcoming clubhouse, and gated access enhance our residents' living experience, making it an outstanding choice for those wanting proximity to both nature and modern amenities in Douglas County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Leila Sweetwater Close to Deer Lick Park",
      "seo_description": "Discover The Leila Sweetwater near Deer Lick Park in Douglas County, offering luxury living and outdoor adventures.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "apartments-by-jessie-davis-park-30122",
      "search_query": "apartments by Jessie Davis Park 30122",
      "category": "Park",
      "h1_title": "Apartments by Jessie Davis Park 30122",
      "h2_subtitle": "Explore premium apartments by Jessie Davis Park, 30122. The Leila Sweetwater offers a perfect blend of nature and comfort.",
      "page_copy": "The Leila Sweetwater boasts prime apartments by Jessie Davis Park, located in the 30122 area. This location offers residents a perfect balance between the tranquility of park-side living and the convenience of modern amenities.\n\nThe community provides a selection of upscale features like granite countertops and relaxing garden tubs. A state-of-the-art clubhouse and a resort-styled swimming pool with a sun deck offer residents a place to unwind and socialize. With gated access, you can enjoy a secure environment while being moments away from the recreational activities at Jessie Davis Park, making The Leila Sweetwater a great choice for quality living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Jessie Davis Park 30122",
      "seo_description": "Live near Jessie Davis Park in 30122 at The Leila Sweetwater. Enjoy luxury amenities and a park-side lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162258",
      "property_id": "6767906449167768",
      "source": "generator",
      "page_item_url": "wallace-park-ga-nearby-apartments",
      "search_query": "Wallace Park GA nearby apartments",
      "category": "Park",
      "h1_title": "Wallace Park GA Nearby Apartments",
      "h2_subtitle": "Discover nearby apartments to Wallace Park, GA. Experience a unique mix of comfort and convenience at The Leila Sweetwater.",
      "page_copy": "Situated near Wallace Park, GA, The Leila Sweetwater offers residents the luxury of staying close to one of Lithia Springs' cherished green spaces. Our community provides a serene environment coupled with superior conveniences that echo modern living.\n\nEnjoy the sophistication of our apartments featuring granite counters and inviting garden tubs. Our resort-inspired swimming pool with a sun-soaked deck, alongside a lively clubhouse, invites relaxation and socialization. With the ease of controlled access, The Leila Sweetwater places you near Wallace Park, offering both a secure community and a direct link to outdoor recreation.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Wallace Park GA Nearby Apartments",
      "seo_description": "Find comfortable, elegant living at nearby apartments to Wallace Park, GA, at The Leila Sweetwater.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6081"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11671058931"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PJ6MJ5VT"
    },
    {
      "ID": "custom_entrata_chatbot",
      "type": "STRING",
      "value": "<script>Object.assign(window, {websiteToken: 'ZVUgUEot9aFSkxYnFCyBiP7F', siteConfig: {clt_i: \"102052\", property_id: \"100160107\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f012059290e25f11"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "b484f0cc984e11eebcb40e136090bd39"
    },
    {
      "ID": "custom_call_rail_company_id",
      "type": "STRING",
      "value": "884272987"
    },
    {
      "ID": "custom_call_rail_account_hash",
      "type": "STRING",
      "value": "019bf4c796a74c0da273"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "3f4d1cea-e689-11f0-b8e2-7b529166620a"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/3f4d1cea-e689-11f0-b8e2-7b529166620a/tour"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImJvMUNoM2ZRWUZ4dWtodGFlbjZVUmc9PSIsInZhbHVlIjoiWHFDV0tMc1FPd05NR00rVTk3aUNiQT09IiwibWFjIjoiODRhMjBiMGY0ZDc0YzMxYjQ0YTQwYjQxYjAxYTk1M2EzNzRmYzYzODczZjcwOTk3ZGQ5ZDY5MTBiMDEyYzFjYiJ9"
    }
  ],
  "custom_qb_id": "6081",
  "custom_repli_id": "11671058931",
  "custom_google_gtm_id": "GTM-PJ6MJ5VT",
  "custom_entrata_chatbot": "<script>Object.assign(window, {websiteToken: 'ZVUgUEot9aFSkxYnFCyBiP7F', siteConfig: {clt_i: \"102052\", property_id: \"100160107\"}});</script><script src=\"https://commoncf.entrata.com/javascript/comms/init.js?ver=1671933\"></script>",
  "custom_knock_community_id": "f012059290e25f11",
  "custom_knock_company_token": "b484f0cc984e11eebcb40e136090bd39",
  "custom_call_rail_company_id": "884272987",
  "custom_call_rail_account_hash": "019bf4c796a74c0da273",
  "custom_eliseai_building_token": "3f4d1cea-e689-11f0-b8e2-7b529166620a",
  "custom_eliseai_organization_id": "ca6e7a0c-0871-4502-b699-60d5f5cfcb57",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/ca6e7a0c-0871-4502-b699-60d5f5cfcb57/3f4d1cea-e689-11f0-b8e2-7b529166620a/tour",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImJvMUNoM2ZRWUZ4dWtodGFlbjZVUmc9PSIsInZhbHVlIjoiWHFDV0tMc1FPd05NR00rVTk3aUNiQT09IiwibWFjIjoiODRhMjBiMGY0ZDc0YzMxYjQ0YTQwYjQxYjAxYTk1M2EzNzRmYzYzODczZjcwOTk3ZGQ5ZDY5MTBiMDEyYzFjYiJ9",
  "custom_audioeye_site_id": "cb8329d2-6840-4652-955d-251e2cfc4847",
  "custom_audioeye_site_hash": "f5f00c1163935b29d8f112cf40299958"
};

export const generatedAt = '2026-10-01T17:22:15.128Z';
